"use strict";

function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(e, r) { return new BabelRegExp(e, void 0, r); }; var e = RegExp.prototype, r = new WeakMap(); function BabelRegExp(e, t, p) { var o = RegExp(e, t); return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype); } function buildGroups(e, t) { var p = r.get(t); return Object.keys(p).reduce(function (r, t) { var o = p[t]; if ("number" == typeof o) r[t] = e[o];else { for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++; r[t] = e[o[i]]; } return r; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) { var t = e.exec.call(this, r); if (t) { t.groups = buildGroups(t, this); var p = t.indices; p && (p.groups = buildGroups(p, this)); } return t; }, BabelRegExp.prototype[Symbol.replace] = function (t, p) { if ("string" == typeof p) { var o = r.get(this); return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function (e, r) { var t = o[r]; return "$" + (Array.isArray(t) ? t.join("$") : t); })); } if ("function" == typeof p) { var i = this; return e[Symbol.replace].call(this, t, function () { var e = arguments; return "object" != _typeof(e[e.length - 1]) && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e); }); } return e[Symbol.replace].call(this, t, p); }, _wrapRegExp.apply(this, arguments); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/* global Storage */
var formLocalStorageKey = "_e_indiain_";
var isRecoveryPage = window.location.href.indexOf('form-recovery') !== -1;
var debugMode = false;
var clearLocalStorage = false;
var validateOn = true;
var isStorageUsing = true;
var supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
var isStepAnimationStarted = false;
var adddays = 5;
var formsent = false;
var disableMails = false;
var formBlocked = false;
var localStorageInterface = {
  _data: {},
  setItem: function setItem(key, value) {
    this._data[key] = value;
  },
  getItem: function getItem(key) {
    return this._data[key];
  },
  removeItem: function removeItem(key) {
    this._data[key] = undefined;
  }
};
var TOURISM_5Y_EXCLUDED_NATIONALITIES = ['13454' // Canada
];
function isSupportForDateInput() {
  $('body').append('<input id="hiddenInput" type="date" value="text-value">');
  var isSupport = $('#hiddenInput').val() !== 'text-value';
  $('#hiddenInput').remove();
  return isSupport;
}
var showBasicDatePicker = supportsTouch;
if (supportsTouch) {
  if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(navigator.userAgent) || !isSupportForDateInput()) {
    showBasicDatePicker = false;
  }
}
function setCalendarSettings() {
  $.ajax({
    url: 'getCalendar',
    method: "GET",
    async: false,
    success: function success(result) {
      result = JSON.parse(result);
      if (typeof result.settings.flightOffset !== 'undefined') {
        adddays = parseInt(result.settings.flightOffset);
      }
      setDateTypeField();
    },
    error: function error() {
      setDateTypeField();
    }
  });
}
if (!Array.prototype.forEach) {
  Array.prototype.forEach = function (fun /*, thisp*/) {
    var len = this.length;
    if (typeof fun != "function") throw new TypeError();
    var thisp = arguments[1];
    for (var i = 0; i < len; i++) {
      if (i in this) fun.call(thisp, this[i], i, this);
    }
  };
}

// change attribute in some element for example change href in  a
function changeObjAttrybute(elem, attrName, attrVal) {
  elem.attr(attrName, attrVal);
}

// change content in some element
function changeObjText(elem, elemVal) {
  elem.html(elemVal);
}
function getTranslationsFromLang() {
  var currLang = $('body').attr('data-current-lang');
  var ajaxParams = [];
  for (var i = 0; i < arguments.length; i++) {
    ajaxParams.push([arguments[i], currLang]);
  }
  var ajaxParamsJson = JSON.stringify(ajaxParams);
  var translations;
  $.ajax({
    type: 'POST',
    url: '//' + window.location.hostname + '/langTranslation',
    data: {
      params: ajaxParamsJson
    },
    dataType: 'json',
    cache: false,
    async: false,
    success: function success(result) {
      translations = result;
    },
    error: function error(e) {
      console.log(e);
    }
  });
  return translations;
}
var translations = getTranslationsFromLang('form field warning', 'form date callendar button prev', 'form date callendar button next', 'form label nonlatin error', 'invalid mimeType');

//////////////////////////////
// show phone number on page
//////////////////////////////

function getPhoneNumbers() {
  $.ajax({
    type: 'POST',
    url: '//' + window.location.hostname + '/get-phone-number',
    data: {
      language: $('body').data('current-lang')
    },
    dataType: 'json',
    cache: false,
    success: function success(result) {
      if (result.status === true) {
        showPagePhone(result.numbers);
      } else {
        $('.callus').remove();
      }
    },
    error: function error(e) {
      console.log(e);
      $.post('/logger.php', {
        data: "JSERR " + window.location.href + "main.js:getPhoneNumbers(): Phone numbers access has been failed"
      });
    }
  });
}
function showPagePhone(phoneNumbers) {
  if (typeof phoneNumbers[0] !== "undefined") {
    var primaryPhone = phoneNumbers[0];
    addPhoneToHeaderElements($('.top-phone-link'), primaryPhone);
    addPhoneToCallusElements($('.top-phone-link2'), primaryPhone);
  }
}
function addPhoneToHeaderElements(header, data) {
  header.attr('href', 'tel:' + data.raw_number).text(data.text);
}
function addPhoneToCallusElements(callus, data) {
  callus.attr('href', 'tel:' + data.raw_number);
  callus.find('.img-lang').attr('src', '/assets/img/flag-' + data.code.toLowerCase() + '.png');
}
function setCalendarTextArrow() {
  var textI18PrevButton = '';
  var textI18NextButton = '';
  if ($('span').hasClass('ui-icon-text-prev-temp')) {
    textI18PrevButton = $('span.ui-icon-text-prev-temp').html();
  } else {
    textI18PrevButton = translations['form date callendar button prev'];
    $('span.ui-icon-text-prev-temp').html(textI18PrevButton);
  }
  if ($('span').hasClass('ui-icon-text-next-temp')) {
    textI18NextButton = $('span.ui-icon-text-next-temp').html();
  } else {
    textI18NextButton = translations['form date callendar button next'];
    $('span.ui-icon-text-next-temp').html(textI18NextButton);
  }
  setTimeout(function () {
    if ($('#ui-datepicker-div .ui-datepicker-group').length > 1) {
      if (!$('a').hasClass('ui-icon-text-prev')) $($("#ui-datepicker-div .ui-datepicker-header")[0]).before("<a class='ui-icon-text-prev' data-event='click' data-handler='prev'>" + textI18PrevButton + "</a>");
      if (!$('a+').hasClass('ui-icon-text-next')) $($("#ui-datepicker-div .ui-datepicker-header")[1]).before("<a class='ui-icon-text-next' data-event='click' data-handler='next'>" + textI18NextButton + "</a>");
    } else {
      if (!$('a').hasClass('ui-icon-text-prev')) $("#ui-datepicker-div .ui-datepicker-header").before("<a class='ui-icon-text-prev' data-event='click' data-handler='prev'>" + textI18PrevButton + "</a>");
      if (!$('a+').hasClass('ui-icon-text-next')) $("#ui-datepicker-div .ui-datepicker-header").before("<a class='ui-icon-text-next' data-event='click' data-handler='next'>" + textI18NextButton + "</a>");
    }
  }, 100);
}
function doYouNeedTableNormalize() {
  var currentWidth = $(window).width();
  if (currentWidth < 744 || supportsTouch && currentWidth <= 1024) {
    $('.countries-table table td:empty').css('border-top', '0px');
  } else {
    $('.countries-table table td:empty').css('border-top', '');
  }
}
function setDateTypeField() {
  if (document.getElementById('form-field-contact-phone')) {
    document.getElementById('form-field-contact-phone').type = 'tel';
  }
  var ftoday = new Date(),
    fyyyy = ftoday.getFullYear(),
    futureyear = fyyyy + 5;
  if (showBasicDatePicker) {
    var minDate = new Date(ftoday.getTime() + adddays * 24 * 60 * 60 * 1000);
    var minDateMonth = minDate.getMonth() + 1;
    var minDateDay = minDate.getDate();
    if (minDateMonth < 10) {
      minDateMonth = '0' + minDateMonth;
    }
    if (minDateDay < 10) {
      minDateDay = '0' + minDateDay;
    }
    $('#form-field-date-of-arrival, #form-field-date-of-embarkation').attr({
      'type': 'date',
      'min': minDate.getFullYear() + '-' + minDateMonth + '-' + minDateDay,
      'max': futureyear + '-' + minDateMonth + '-' + minDateDay
    });
  } else {
    var minDateOut = new Date(ftoday.getTime() + adddays * 24 * 60 * 60 * 1000);
    $('#form-field-date-of-arrival, #form-field-date-of-embarkation').datepicker({
      minDate: minDateOut,
      dateFormat: "dd/mm/yy",
      timepicker: false,
      prevText: "",
      nextText: "",
      onChangeMonthYear: function onChangeMonthYear() {
        setCalendarTextArrow();
      },
      numberOfMonths: window.innerWidth > 760 ? 2 : 1
    }).bind('click keyup', function () {
      setCalendarTextArrow();
    });
    $('.ui-datepicker').addClass('notranslate');
    // Lock manual entry
    $(".disable-input input").attr('readonly', true);
  }
  window.insuranceEnabled && addInsuranceDatepicker();
}
$(function () {
  getPhoneNumbers();

  // do you need table cosmetics change
  doYouNeedTableNormalize();

  // window resize for do you need table cosmetics change
  $(window).resize(function () {
    doYouNeedTableNormalize();
  });
  try {
    localStorage.setItem('localStorage', 1);
    localStorage.removeItem('localStorage');
  } catch (e) {
    Storage.prototype._setItem = Storage.prototype.setItem;
    Storage.prototype.setItem = function () {};
    isStorageUsing = false;
  }

  // Remove old storage
  if (isStorageUsing) {
    var lastDate = localStorage.getItem(formLocalStorageKey + '_date');
    if (lastDate !== null && parseInt(lastDate) + 5 * 24 * 60 * 60 * 1000 < Date.now()) {
      localStorage.removeItem(formLocalStorageKey);
      localStorage.removeItem(formLocalStorageKey + '_date');
    }
  }

  // set calendar for mobile or desktop
  setCalendarSettings();
  $(window).keydown(function (event) {
    if (event.keyCode === 13) {
      return false;
    }
  });
  setVisibilityOfFileData();
  $('#form select').val('');

  // Load form
  if (isRecoveryPage) {
    loadForm($('#apply-form-data').data('form'));
  } else {
    loadForm(false);
  }

  //
  //  Main function for hiding/showing hidden fields
  //
  hiddenFieldController();
  invoiceHiddenForm();
  buisnessFieldsController();
  patientFieldsController();
  processForm();
  latinInputs();
  employmentShowHide();
  $('.with-hint').tooltip({
    position: {
      at: "center top"
    },
    content: function content() {
      var el = $(this);
      var content = el.attr('title');
      return content;
    }
  });

  // Add readonly to inputs if parent container has class ".disable-input"
  // $(".disable-input input").attr('readonly', true);

  //
  // cookiesWarning
  //
  cookiesWarning();

  //
  //  Form label  equal height
  //
  formLabelsEqual();

  //
  // Terms read more
  //
  $('.terms-read-more').click(function (e) {
    var $terms = $('.accept-terms-long');
    $terms.toggleClass('full-text');
  });
  $('.step-1').css('cursor', 'pointer');
  $('.step-1').click(function (e) {
    window.location.href = document.getElementById("booketa").href;
  });
  $('.list-container').click(function () {
    window.onbeforeunload = null;
  });

  //
  // Font resizer
  //
  $('.font-size').click(function (e) {
    var fsize = $(this).hasClass('font-size-plus') ? 1 : -1;
    ga('send', 'event', 'lupki', fsize == 1 ? "plus" : "minus");
    $('main *, footer *').each(function () {
      var $obj = $(this);
      $obj.css('font-size', parseInt($obj.css('font-size')) + fsize + "px");
    });
  });

  //
  // Languages & Phone menus
  //
  dropdownMenus();

  //
  // Card proccessing form
  //
  cardProcessingForm();
  //
  // Payment form rwd
  //
  var $paymentForm = $('#payment-form');
  var $colFirstName = $('.col-first-name');
  var $colLastName = $('.col-last-name');
  if ($paymentForm.length && $(window).width() <= 720) {
    $colLastName.insertAfter($colFirstName);
  }

  //
  // Passort number helper
  //
  //S8 TOTAL FUCKUP    passportNumberHelper();

  //
  // show application no if storage isset
  //
  if (!isRecoveryPage) {
    showApplicationNo();
  }
  document.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      var radioChecked = radio.nextElementSibling,
        oldDisplay = radioChecked.style.display;
      radioChecked.style.display = 'none';
      radioChecked.style.display = oldDisplay;
    });
  });
  initializeTermsLogic();
});
var expensiveCountries = [13384,
// mozambique
13328,
// russia
13331,
// ukraine
13278,
// england
13282,
// northern ireland
13283,
// scotland
13284,
// wales
13452,
// usa
13277 // United Kingdom And Colonies
];
function changeTermsPrice(visaType) {
  var selectedNationality = parseInt($('[name="form[nationality]"]').val());
  var selectedPassportCountry = parseInt($('[name="form[passport-country]"]').val());
  if ($('input[name=form\\[payment-type\\]][type=radio]').length > 0) {
    $('input[name=form\\[payment-type\\]][type=radio]').change(function (e) {
      if ($(this)[0].checked === true) {
        var getPrice = $(this)[0].attributes['data-src'].value;
        getPrice = getPrice.split('/');
        if (expensiveCountries.indexOf(selectedNationality) > -1 || expensiveCountries.indexOf(selectedPassportCountry) > -1) {
          $('.priceToChange').text(getPrice[1]);
        } else {
          $('.priceToChange').text(getPrice[0]);
        }
      }
    }).trigger('change');
  } else {
    if (expensiveCountries.indexOf(selectedNationality) > -1 || expensiveCountries.indexOf(selectedPassportCountry) > -1) {
      $('.priceToChange').text('149 EUR');
    } else {
      $('.priceToChange').text('129 EUR');
    }
  }
}
function showApplicationNo() {
  var data = storageDataToObj();
  if (data !== undefined && data !== null && data.initializeData !== undefined) {
    var AppNumber = data.initializeData.application_no;
    var AppHash = data.initializeData.hash;
    if (typeof AppNumber !== "undefined" && AppNumber !== '' && typeof AppHash !== "undefined" && AppHash !== '') {
      $('.form-application-content-no .form-application-no').remove();
      $('.form-application-content-no').append($('<span class="form-application-no">').text(AppNumber), $('<span class="form-application-hash hidden">').text(AppHash)).removeClass('hidden');
    }
  }
}
function getFormDataAsJson() {
  var appNumber = $('.form-application-no').eq(0).text(),
    appHash = $('.form-application-hash').eq(0).text();
  return {
    initializeData: {
      application_no: appNumber,
      hash: appHash
    },
    fields: getFieldsForm()
  };
}
function latinInputs() {
  var $inputs = $(".latin-only, input.latin-only");

  // Disable pasting
  $inputs.on("paste", function (e) {
    e.preventDefault();
    return;
  });
  $inputs.keypress(function (e) {
    var key = e.keyCode ? e.keyCode : e.which;
    if (!(key >= 65 && key <= 90 || key >= 97 && key <= 122 || key == 32)) {
      e.preventDefault();
    }
  });
}
function invoiceHiddenForm() {
  var $formSelector = $('[name="form[invoice]"]');
  $formSelector.on('change', function () {
    var $obj = $(this);
    var checked = $obj.prop('checked');
    if (checked) {
      $('.invoice-hidden-row').removeClass('hidden');
      formLabelsEqual();
    } else {
      $('.invoice-hidden-row').addClass('hidden');
    }
  }).trigger('change');
}
var clearRelatedFieldsValues = function clearRelatedFieldsValues(selector) {
  $(selector).find('input, select, textarea').not(':button, :submit').each(function () {
    $(this).prop('type') === 'checkbox' || $(this).prop('type') === 'radio' ? $(this).prop('checked', false) : $(this).val('');
    $(this).removeClass('with-error with-success');
  });
};
function toggleVisaTypeBasedOnNationality(nationality) {
  if (TOURISM_5Y_EXCLUDED_NATIONALITIES.includes(nationality)) {
    $('[name="form[dov-purpose]"] [value="tourism-5Y"]').attr('disabled', 'disabled').trigger('change');
    if ($('[name="form[dov-purpose]"] :selected').val() === 'tourism-5Y') {
      $('[name="form[dov-purpose]"]').val('');
    }
  } else {
    $('[name="form[dov-purpose]"] [value="tourism-5Y"]').removeAttr('disabled').trigger('change');
  }
}
function toggleEntryDocumentFields() {
  if ($('#form-field-dov-purpose').val() === 'transit') {
    $('#form-field-destination-country').parent().removeClass('hidden');
    $('#form-field-entry-document-type').parent().removeClass('hidden');
  } else {
    $('#form-field-destination-country').val('').trigger('change').parent().addClass('hidden');
    $('#form-field-entry-document-type').val('').trigger('change').parent().addClass('hidden');
  }
}
function hiddenFieldController() {
  $('[name="form[nationality]"]').change(function () {
    var value = $(this).val();
    toggleVisaTypeBasedOnNationality(value);
  }).trigger('change');

  // Have your mother gots other nationality
  $('[name="form[mother-nationality-previous-question]"]').change(function () {
    var value = $('[name="form[mother-nationality-previous-question]"]:checked').val();
    if (value == 1) {
      $(".mother-nationality-previous").removeClass("hidden");
    } else {
      $(".mother-nationality-previous").addClass("hidden");
      clearRelatedFieldsValues('.mother-nationality-previous');
    }
  }).trigger('change');

  // Have your father gots other nationality
  $('[name="form[father-nationality-previous-question]"]').change(function () {
    var value = $('[name="form[father-nationality-previous-question]"]:checked').val();
    if (value == 1) {
      $(".father-nationality-previous").removeClass("hidden");
    } else {
      $(".father-nationality-previous").addClass("hidden");
      clearRelatedFieldsValues('.father-nationality-previous');
    }
  }).trigger('change');

  // Shows text field for religion description, if user selected "other"
  $("#form-field-religion").change(function (e) {
    if ($(this).val() == "others") {
      $("#form-field-religion-description").parent().removeClass("hidden");
    } else {
      $("#form-field-religion-description").parent().addClass("hidden");
    }
  }).trigger('change');

  // Shows text field for visible identification marks description
  $('[name="form[identification-marks-question]"]').change(function (e) {
    var value = $('[name="form[identification-marks-question]"]:checked').val();
    if (value == 1) {
      $("#form-field-identification-marks-answer").parent().removeClass("hidden");
    } else {
      $("#form-field-identification-marks-answer").parent().addClass("hidden");
      clearRelatedFieldsValues('.identification-marks-answer');
    }
  }).trigger('change');

  // Shows select field for previous nationality
  $("#form-field-nationality-type").change(function () {
    if ($(this).val() == "naturalization") {
      $("#form-field-nationality-previous").parent().removeClass("hidden");
    } else {
      $("#form-field-nationality-previous").parent().addClass("hidden");
    }
  }).trigger('change');

  // Shows additional passport hidden fields
  $('[name="form[any-other-valid-passport-question]"]').change(function () {
    var value = $('[name="form[any-other-valid-passport-question]"]:checked').val();
    if (value == 1) {
      $(".additional-passport-fields").removeClass("hidden");
    } else {
      $(".additional-passport-fields").addClass("hidden");
      clearRelatedFieldsValues('.additional-passport-fields');
    }
  }).trigger('change');

  // Shows spouse hidden fields
  $("#form-field-applicant-marital-status").change(function () {
    if ($(this).val() == "married") {
      $(".spouse-fields").removeClass("hidden");
    } else {
      $(".spouse-fields").addClass("hidden");
      clearRelatedFieldsValues('.spouse-fields');
    }
  }).trigger('change');

  // Pakistan held area
  $('[name="form[pakistan-held-area-question]"]').change(function () {
    var value = $('[name="form[pakistan-held-area-question]"]:checked').val();
    if (value == 1) {
      $(".pakistan-held-area-answer").removeClass("hidden");
    } else {
      $(".pakistan-held-area-answer").addClass("hidden");
    }
  }).trigger('change');

  // Occupation other
  $('#form-field-employment-profession').change(function () {
    if ($(this).val() == "others") {
      $("#form-field-employment-profession-other").parent().removeClass("hidden");
    } else {
      $("#form-field-employment-profession-other").parent().addClass("hidden");
    }
  }).trigger('change');
  $('#form-field-port-of-arrival').change(function () {
    if (Object.keys(seaPorts).includes($(this).val())) {
      $('#form-field-date-of-embarkation').closest('.fields-column').removeClass('hidden');
    } else {
      $('#form-field-date-of-embarkation').closest('.fields-column').addClass('hidden');
      $('#form-field-date-of-embarkation').val('').trigger('change');
    }
    toggleFastTrack();
    formLabelsEqual();
  }).trigger('change');
  $('#form-field-date-of-embarkation, #form-field-date-of-arrival').change(function () {
    var isSeaport = ['8', '10', '15', '23', '25'].includes($('#form-field-port-of-arrival').val());
    var isTourism30D = ['tourism-30D'].includes($('#form-field-dov-purpose').val());
    var dateFieldSeparator = '-';
    if (!showBasicDatePicker) {
      dateFieldSeparator = '/';
    }
    var arr = $('#form-field-date-of-embarkation').val().split(dateFieldSeparator);
    var embarkationDate = showBasicDatePicker ? new Date(arr[0], parseInt(arr[1]) - 1, arr[2]) : new Date(arr[2], parseInt(arr[1]) - 1, arr[0]);
    arr = $('#form-field-date-of-arrival').val().split(dateFieldSeparator);
    var arrivalDate = showBasicDatePicker ? new Date(arr[0], parseInt(arr[1]) - 1, arr[2]) : new Date(arr[2], parseInt(arr[1]) - 1, arr[0]);
    var differenceInDays = (arrivalDate.getTime() - embarkationDate.getTime()) / 1000 / 60 / 60 / 24;
    if (isSeaport && differenceInDays > 15 && isTourism30D) {
      $('#form-field-dov-purpose').val('tourism-1Y').trigger('change');
      if (!$('[name="form[dov-purpose-tourism]"]:checked').val()) {
        $('[name="form[dov-purpose-tourism]"]')[0].checked = true;
      }

      // TODO
      $('#changedVisaTypeModal').show();
    }
  });
  $('#accept1YChange').click(function () {
    $('#changedVisaTypeModal').hide();
  });

  // Are/were you in a Military/Semi-Military/Police/Security. Organization?
  $('[name="form[military-organization-question]"]').change(function () {
    var value = $('[name="form[military-organization-question]"]:checked').val();
    if (value == 1) {
      $(".military-organization-fields").removeClass("hidden");
    } else {
      $(".military-organization-fields").addClass("hidden");
      clearRelatedFieldsValues('.military-organization-fields');
    }
  }).trigger('change');

  // have you visited saarc countries
  $('[name="form[dov-saarc-question]"]').change(function () {
    var value = $('[name="form[dov-saarc-question]"]:checked').val();
    if (value == 1) {
      $(".dov-saarc-fields").removeClass("hidden");
    } else {
      $(".dov-saarc-fields").addClass("hidden");
      clearRelatedFieldsValues('.dov-saarc-fields');
    }
  }).trigger('change');

  // have you visited india before
  $('[name="form[visited-india]"]').change(function () {
    var value = $('[name="form[visited-india]"]:checked').val();
    if (value == 1) {
      $(".visited-india-fields").removeClass("hidden");
    } else {
      $(".visited-india-fields").addClass("hidden");
      clearRelatedFieldsValues('.visited-india-fields');
    }
  }).trigger('change');

  // buisness purpouse of visit

  //////////////////
  //  fields to use
  //////////////////

  ////////////////////////////////////////
  //                                    //
  //   business-company-name            //
  //   business-company-address         //
  //   business-company-website         //
  //   business-company-phone           //
  //                                    //
  //   business-company-type            //
  //   business-indian-company-name     //
  //   business-indian-company-address  //
  //   business-indian-company-website  //
  //   business-indian-company-phone    //
  //   business-representative-name     //
  //   business-job-recruting           //
  //   business-place-conducted         //
  //   business-exhibition-name         //
  //   business-agency-data             //
  //   business-visited-cities          //
  //   business-agent-name              //
  //   business-agent-address           //
  //                                    //
  ////////////////////////////////////////

  $('#form-field-dov-purpose').on('change', function () {
    visaTypeFieldsController();
    toggleEntryDocumentFields();
  }).trigger('change');
  $('[name="form[dov-purpose-tourism]"]').on('change', function () {
    clearTouristSections();
    tourismFieldsController();
    visaTypeFieldsController();
  }).trigger('change');
  $('[name="form[patient-choose-document]"]').on('change', function () {
    patientFieldsController();
  });
  $('[name="form[dov-purpose-business]"]').on('change', function () {
    buisnessFieldsController();
    saveApplicationInBase();
  });
}
function visaTypeFieldsController(visaType) {
  var businessPurpose = $('[name="form[dov-purpose-business]"]');
  var tourismPurpose = $('[name="form[dov-purpose-tourism]"]');
  var medicalLetterScan = $('[name="form[hospital-medical-letter-scan]"]');
  var businessCardScan = $('[name="form[user-business-card-scan]"]');
  var patientDetailsSection = $('.patientDetails');
  var conferenceDetails = $('.conferenceDetails');
  var conferenceDocuments = $('[name="form[conference-organizer-invitation-scan]"], ' + '[name="form[conference-MEA-clearance-scan]"], ' + '[name="form[conference-MHA-clearance-scan]"]');
  var invitationLetterVoluntary = $('[name="form[invitation-letter-voluntary]"]');
  var invitationLetterMedical = $('[name="form[medical-invitation-letter]"]');
  businessPurpose.closest('.fields-column').addClass('hidden');
  tourismPurpose.closest('.fields-column').addClass('hidden');
  medicalLetterScan.closest('.fields-column').addClass('hidden');
  businessCardScan.closest('.fields-column').addClass('hidden');
  patientDetailsSection.addClass('hidden');
  conferenceDetails.addClass('hidden');
  conferenceDocuments.closest('.fields-column').addClass('hidden');
  invitationLetterVoluntary.closest('.fields-column').addClass('hidden');
  $('.friendDetails').addClass('hidden');
  $('.yogaDetails').addClass('hidden');
  $('.business-extend-group').addClass('hidden');
  $('.indian-company-data').addClass('hidden');
  visaType = $('#form-field-dov-purpose').val();
  if (visaType && !['business', 'tourism-1Y', 'ayou', 'medtreat', 'medatt', 'econference'].includes(visaType)) {
    $('#form-field-date-of-embarkation, #form-field-date-of-arrival').val('').trigger('change');
  }
  switch (visaType) {
    case 'business':
      $('.business-extend-group:not(.indian-company-data)').removeClass('hidden');
      businessPurpose.closest('.fields-column').removeClass('hidden');
      $('#form-field-user-business-card-scan').closest('.fields-column').removeClass('hidden');
      medicalLetterScan.closest('.fields-column').addClass('hidden');
      invitationLetterMedical.val('').removeClass('with-error with-success').closest('.fields-column').addClass('hidden');
      clearRelatedFieldsValues('.medical-invitation-letter');
      tourismPurpose.prop('checked', false);
      clearPatientSection();
      buisnessFieldsController();
      break;
    case 'tourism-30D':
    case 'tourism-1Y':
    case 'tourism-5Y':
    case 'transit':
      invitationLetterMedical.val('').removeClass('with-error with-success').closest('.fields-column').addClass('hidden');
      medicalLetterScan.closest('.fields-column').addClass('hidden');
      if (visaType !== 'transit') {
        tourismPurpose.closest('.fields-column').removeClass('hidden');
      }
      businessPurpose.prop('checked', false);
      if ($('[name="form[dov-purpose-tourism]"]:checked').val() === 'voluntary') {
        invitationLetterVoluntary.closest('.fields-column').removeClass('hidden');
      }
      clearPatientSection();
      break;
    case 'ayou':
    case 'medtreat':
      invitationLetterMedical.removeClass('with-error with-success').closest('.fields-column').removeClass('hidden');
      medicalLetterScan.closest('.fields-column').removeClass('hidden');
      clearTourismAndBusinessPurpose();
      break;
    case 'medatt':
      invitationLetterMedical.val('').removeClass('with-error with-success').closest('.fields-column').addClass('hidden');
      clearTourismAndBusinessPurpose();
      patientDetailsSection.removeClass('hidden');
      break;
    case 'econference':
      invitationLetterMedical.val('').removeClass('with-error with-success').closest('.fields-column').addClass('hidden');
      clearTourismAndBusinessPurpose();
      conferenceDetails.removeClass('hidden');
      conferenceDocuments.closest('.fields-column').removeClass('hidden');
      break;
    default:
      clearTourismAndBusinessPurpose();
      break;
  }
  function clearTourismAndBusinessPurpose() {
    businessPurpose.prop('checked', false);
    tourismPurpose.prop('checked', false);
  }
}
function clearPatientSection() {
  $('.patientDetails input[type="text"]').val("");
  $('.patientDetails input[type="radio"]:checked').prop('checked', false);
}
function clearTouristSections() {
  if ($('[name="form[dov-purpose-tourism]"]:checked').val() !== 'yoga') {
    $('.yogaDetails input[type="text"]').val("");
  }
  if ($('[name="form[dov-purpose-tourism]"]:checked').val() !== 'meeting') {
    $('.friendDetails input[type="text"]').val("");
  }
}
function tourismFieldsController() {
  var visaType = $('#form-field-dov-purpose').val();
  var tourismPurpose = $('[name="form[dov-purpose-tourism]"]:checked').val();
  var friendDetails = $('.friendDetails');
  var yogaDetails = $('.yogaDetails');
  var invitationLetter = $('.invitationLetter');
  friendDetails.addClass('hidden');
  yogaDetails.addClass('hidden');
  invitationLetter.addClass('hidden');
  switch (tourismPurpose) {
    case 'meeting':
      if (['tourism-30D', 'tourism-1Y', 'tourism-5Y', 'transit'].includes(visaType)) {
        friendDetails.find('.with-success').removeClass('with-success');
        friendDetails.find('.with-error').removeClass('with-error');
        friendDetails.removeClass('hidden');
      }
      break;
    case 'yoga':
      yogaDetails.find('.with-success').removeClass('with-success');
      yogaDetails.find('.with-error').removeClass('with-error');
      yogaDetails.removeClass('hidden');
      invitationLetter.removeClass('hidden');
      break;
    case 'courses':
      invitationLetter.removeClass('hidden');
      break;
  }
}
function patientFieldsController() {
  var documentType = $('[name="form[patient-choose-document]"]:checked').val();
  var applicationIdField = $('#form-field-patient-application-id');
  var visaIdField = $('#form-field-patient-visa-id');
  applicationIdField.closest('.fields-column').addClass('hidden');
  visaIdField.closest('.fields-column').addClass('hidden');
  switch (documentType) {
    case 'application':
      applicationIdField.closest('.fields-column').removeClass('hidden');
      break;
    case 'visa':
      visaIdField.closest('.fields-column').removeClass('hidden');
      break;
  }
}
function employmentShowHide() {
  $('#form-field-employment-information').on('change', function () {
    var birthDate = new Date($('#form-field-birth-year option:selected').text(), $('#form-field-birth-month option:selected').index() - 1, parseInt($('#form-field-birth-day option:selected').text()));
    var tempDate = new Date();
    tempDate.setFullYear(tempDate.getFullYear() - 18);
    var isMinor = true;
    if (birthDate instanceof Date && !isNaN(birthDate)) {
      var isMinor = birthDate.getTime() > tempDate.getTime();
    }
    var employmentBlock = $('.employment-basic-info'),
      employmentJobType = $('#form-field-employment-information'),
      employmentJobDetails = $('.employment-job-details'),
      employmentStudentDetails = $('.studentDetails');
    if (isMinor) {
      employmentBlock.addClass("hidden");
      employmentJobType.addClass("hidden").val('').removeClass('with-error');
      employmentJobDetails.addClass("hidden").find('input, select').val('').removeClass('with-error');
    } else {
      employmentBlock.removeClass("hidden");
      employmentJobType.removeClass("hidden").removeClass('with-error');
      // is employed
      if (employmentJobType.val() !== 'employed') {
        employmentJobDetails.addClass("hidden").find('input, select').val('').removeClass('with-error');
      } else if (employmentJobType.val() !== 'student') {
        employmentStudentDetails.addClass("hidden").find('input, select').val('').removeClass('with-error');
      } else {
        employmentJobDetails.removeClass("hidden").find('input, select').removeClass('with-error');
        employmentStudentDetails.addClass("hidden").find('input, select').val('').removeClass('with-error');
      }
      switch (employmentJobType.val()) {
        case 'employed':
          employmentStudentDetails.addClass("hidden").find('input, select').val('').removeClass('with-error');
          employmentJobDetails.removeClass("hidden").find('input, select').removeClass('with-error');
          break;
        case 'student':
          employmentJobDetails.addClass("hidden").find('input, select').val('').removeClass('with-error');
          employmentStudentDetails.removeClass("hidden").find('input, select').removeClass('with-error');
          break;
        default:
          employmentJobDetails.addClass("hidden").find('input, select').val('').removeClass('with-error');
          employmentStudentDetails.addClass("hidden").find('input, select').val('').removeClass('with-error');
          clearRelatedFieldsValues('.employment-job-details');
          break;
      }
    }
  }).trigger('change');
}
function setVisibilityOfFileData() {
  $('[name="form[photolater]"]').on('change', function () {
    if ($(this).prop('checked') && !$('.file-data-container').hasClass('hidden')) {
      $('.file-data-container').addClass('hidden');
      $('.photolater-notice').removeClass('hidden');
    } else if (!$(this).prop('checked') && $('.file-data-container').hasClass('hidden')) {
      $('.file-data-container').removeClass('hidden');
      $('.photolater-notice').addClass('hidden');
    }
  }).trigger('change');
}
function passportNumberHelper() {
  var $field = $('[name="form[passport-number]"], [name="check[passport_number]"]');
  var validChars = new RegExp("[a-zA-Z0-9]");
  var invalidChars = new RegExp("[oO]");
  $field.on('keypress', function (e) {
    var key = e.keyCode ? e.keyCode : e.which;
    var _char = String.fromCharCode(key);
    if (!validChars.test(_char) && key != 8) {
      e.preventDefault();
      return;
    }
  }).trigger('keypress');
  $field.on('keyup', function () {
    $field.val($field.val().toUpperCase());
  });
}
function cardProcessingForm() {
  var $form = $('#card-processing-form');
  var $btn = $form.find('[type="submit"]');
  var $message = $('.payment-status');
  $form.submit(function (e) {
    e.preventDefault();
    $btn.prop('disabled', true).addClass('loading');
    $message.html("").removeClass('show-error').removeClass('show-success');
    $.ajax({
      url: $form.attr('action'),
      method: "POST",
      dataType: "json",
      data: $form.serialize(),
      success: function success(response) {
        if (response.status == true) {
          window.onbeforeunload = null;
          window.location.href = $form.attr('data-success-redirect');
          $form.hide();
          $message.html(response.message).removeClass('show-error').addClass('show-success');
        } else {
          $message.html(response.message).removeClass('show-success').addClass('show-error');
        }
        $btn.prop('disabled', false).removeClass('loading');
      },
      error: function error(response) {
        console.log(response.responseText);
        $btn.prop('disabled', false).removeClass('loading');
      }
    });
  });
}
function dropdownMenus() {
  var languages = $('.languages .list-container'),
    phones = $('#dropdown-phone-list');
  $('.languages .current .wrapper').on('click', function () {
    languages.toggle();
  });
  $('#dropdown-phone-button').on('click', function () {
    phones.toggle();
  });
  $(document).click(function (event) {
    if (!$(event.target).closest('.languages .current .wrapper').length) {
      languages.hide();
    }
    if (!$(event.target).closest('#dropdown-phone-button').length) {
      phones.hide();
    }
  });
}
function formLabelsEqual() {
  var rows = $('.form-row-fields');
  if ($(window).width() <= 767) {
    $('.fields-column:visible:not(.clearfix)').css('height', 'auto');
    return;
  }
  rows.each(function () {
    var columns = $(this).children('.fields-column:visible:not(.file-data):not(.radio-column):not(.noequalize)');
    if (columns.length < 2) {
      return;
    }
    columns.css('height', 'auto');
    var heights = [];
    columns.each(function () {
      heights.push(parseInt($(this).innerHeight()));
    });
    heights.sort(sortNumbers);
    var maxHeight = heights[heights.length - 1];
    if (maxHeight > 0) {
      columns.css('height', maxHeight);
    }
  });
}
showQuestions();
function showQuestions() {
  $('[name="form[criminal-question-arrested]"]').on('change', function () {
    if (this.value == 1) {
      $('#form-field-criminal-question-arrested-details').parent().removeClass('hidden');
    } else {
      $('#form-field-criminal-question-arrested-details').parent().addClass('hidden');
    }
  }).trigger('change');
  $('[name="form[criminal-question-deported]"]').on('change', function () {
    if (this.value == 1) {
      $('#form-field-criminal-question-deported-details').parent().removeClass('hidden');
    } else {
      $('#form-field-criminal-question-deported-details').parent().addClass('hidden');
    }
  }).trigger('change');
  $('[name="form[criminal-question-drug]"]').on('change', function () {
    if (this.value == 1) {
      $('#form-field-criminal-question-drug-details').parent().removeClass('hidden');
    } else {
      $('#form-field-criminal-question-drug-details').parent().addClass('hidden');
    }
  }).trigger('change');
  $('[name="form[criminal-question-cyber-crime]"]').on('change', function () {
    if (this.value == 1) {
      $('#form-field-criminal-question-cyber-crime-details').parent().removeClass('hidden');
    } else {
      $('#form-field-criminal-question-cyber-crime-details').parent().addClass('hidden');
    }
  }).trigger('change');
  $('[name="form[criminal-question-terrorist]"]').on('change', function () {
    if (this.value == 1) {
      $('#form-field-criminal-question-terrorist-details').parent().removeClass('hidden');
    } else {
      $('#form-field-criminal-question-terrorist-details').parent().addClass('hidden');
    }
  }).trigger('change');
  $('[name="form[criminal-question-asylum]"]').on('change', function () {
    if (this.value == 1) {
      $('#form-field-criminal-question-asylum-details').parent().removeClass('hidden');
    } else {
      $('#form-field-criminal-question-asylum-details').parent().addClass('hidden');
    }
  }).trigger('change');
}
// do actions when field is associated
function associatedValidFields($obj) {
  // buisness purpouse of visit after load
  if ($obj.attr('id') == 'form-field-dov-purpose') {
    // przy przeładowaniu strony

    if ($('#form-field-dov-purpose').val() == 'business') {
      $('[name="form[dov-purpose-business]"]').closest('.fields-column').removeClass('hidden');
      $('#form-field-user-business-card-scan').closest('.fields-column').removeClass('hidden');
      $('#form-field-user-business-card-snapshot').parent().removeClass('hidden');
    } else if (['tourism-30D', 'tourism-1Y', 'tourism-5Y'].includes($('#form-field-dov-purpose').val())) {
      $('[name="form[dov-purpose-tourism]"]').closest('.fields-column').removeClass('hidden');
    } else {
      // ( ! $('#form-field-dov-purpose-business').parent().hasClass('hidden') )
      $('#form-field-user-business-card-snapshot').parent().addClass('hidden');
      $('#form-field-dov-purpose-business').parent().addClass('hidden');
      $('#form-field-dov-purpose-business').val('');
      // clear all business fields whit buisness scan
      buisnessFieldsDisable();
    }
  }

  // buisness purpouse fields of visit after load
  if ($obj.attr('id') == 'form-field-dov-purpose-business' && $obj.val() != '') {
    // disable all if val is empty or show when field is set
    buisnessFieldsController();
  }
}
function buisnessFieldsDisable() {
  var allBusinessFields = ['business-company-name', 'business-company-address', 'business-company-website', 'business-company-phone', 'business-company-type', 'business-indian-company-name', 'business-indian-company-address', 'business-indian-company-website', 'business-representative-name', 'business-job-recruting', 'business-place-conducted', 'business-exhibition-name', 'business-agency-data', 'business-visited-cities', 'business-agent-name', 'business-agent-address'];
  allBusinessFields.forEach(function (item) {
    $('#form-field-' + item).parent().addClass('hidden');
    $('#form-field-' + item).val('');
  });
  $('#form-field-user-business-card-scan').closest('.fields-column').addClass('hidden');
  $('#form-field-user-business-card-scan-holder').val('');
}
function buisnessFieldsController() {
  var current = $('#form-field-dov-purpose').val();
  var currentVal = $('[name="form[dov-purpose-business]"]:checked').val();
  // set all hidden

  if (current != "business") {
    currentVal = null;
  }
  $('.business-extend-group').find('input').parent().addClass('hidden');
  $('.indian-company-data').addClass('hidden');

  // show container
  if (currentVal == '' || currentVal == null) {
    $('.business-extend-group').addClass('hidden');
  } else if (currentVal === 'meetings' || currentVal === 'ongoing') {
    $('.business-extend-group').removeClass('hidden');
  } else {
    $('.business-extend-group:not(.indian-company-data)').removeClass('hidden');
    $('.indian-company-data').addClass('hidden');
  }
  var fieldsToShow;

  // set item to show
  switch (currentVal) {
    case 'venture':
      {
        fieldsToShow = ['business-company-name', 'business-company-address', 'business-company-phone', 'business-company-website', 'business-company-type'];
        break;
      }
    case 'trade':
      {
        fieldsToShow = ['business-company-name', 'business-company-address', 'business-company-phone', 'business-company-website', 'business-company-type'];
        break;
      }
    case 'meetings':
      {
        fieldsToShow = ['business-company-name', 'business-company-address', 'business-company-phone', 'business-company-website', 'business-indian-company-phone', 'business-indian-company-name', 'business-indian-company-address', 'business-indian-company-website'];
        break;
      }
    case 'manpower':
      {
        fieldsToShow = ['business-company-name', 'business-company-address', 'business-company-phone', 'business-company-website', 'business-representative-name', 'business-job-recruting', 'business-place-conducted'];
        break;
      }
    case 'fairs':
      {
        fieldsToShow = ['business-company-name', 'business-company-address', 'business-company-phone', 'business-company-website', 'business-exhibition-name'];
        break;
      }
    case 'ongoing':
      {
        fieldsToShow = ['business-company-name', 'business-company-address', 'business-company-phone', 'business-company-website', 'business-indian-company-phone', 'business-indian-company-name', 'business-indian-company-address', 'business-indian-company-website'];
        break;
      }
    case 'conducting':
      {
        fieldsToShow = ['business-agency-data', 'business-visited-cities', 'business-agent-name', 'business-agent-address'];
        break;
      }
    case 'lecture':
      {
        fieldsToShow = ['business-company-name', 'business-company-address', 'business-company-phone', 'business-company-website', 'business-company-type'];
        break;
      }
    default:
      {
        fieldsToShow = [];
        break;
      }
  }
  var allBusinessFields = ['business-company-name', 'business-company-address', 'business-company-website', 'business-company-phone', 'business-company-type', 'business-indian-company-name', 'business-indian-company-phone', 'business-indian-company-address', 'business-indian-company-website', 'business-representative-name', 'business-job-recruting', 'business-place-conducted', 'business-exhibition-name', 'business-agency-data', 'business-visited-cities', 'business-agent-name', 'business-agent-address'];

  // show selected items
  allBusinessFields.forEach(function (item) {
    if (fieldsToShow.indexOf(item) != -1) {
      $('#form-field-' + item).parents().removeClass('hidden');
    } else {
      // clear data from hidden fields
      var hiddenFieldVal = $('#form-field-' + item).val();
      if (hiddenFieldVal != '' && hiddenFieldVal != undefined) {
        $('#form-field-' + item).val('');
      }
    }
  });
}
function validActiveStep(currentSection, stepToActive) {
  invoiceHiddenForm();
  hiddenFieldController();
  var fields = currentSection.find('[data-required]');
  var focused = false;
  var validationDataInput = $('[name="form[validation-data]"]');

  // remove all errors befoure validate
  $('.with-error').removeClass('with-error');
  $('.file-with-error').removeClass('file-with-error');
  var fieldsLengths = fields.length;
  var out = {
    'pass': true,
    'item': {}
  };
  for (var i = 0; i < fieldsLengths; i++) {
    var $obj = $(fields[i]);

    // associated fields whit curent field
    associatedValidFields($obj);

    // get fields from not having hidden class
    var visible = !$obj.parents().hasClass('hidden');
    if (visible) {
      var defaultValidateField = false;
      $obj.parents().map(function () {
        if (!validateOn) {
          var elemAttr = $(this).attr('data-always-validate');
          if (elemAttr === 'yes') defaultValidateField = true;
        }
      });
      if (!validateOn && !defaultValidateField) {
        $obj.addClass('with-success');
        continue;
      }
      var isValid = '';
      // match form name
      var regex = new RegExp(/^form\[(.*?)\]$/);
      var match = regex.exec($obj.attr('name'));
      var currentValidateData = validationDataInput.val();
      isValid = validateField($obj);
      // console.log(fields[i]);
      // console.log(isValid);
      if (!isValid) {
        if (!focused) {
          focused = true;
          out = {
            'pass': false,
            'item': $obj
          };
        }

        // break;
      } else if (currentValidateData.search(match[1]) == -1) {
        validationDataInput.val(validationDataInput.val() + match[1] + ";");
      }
    }
  }
  return out;
}
function animateFormStep(stepToActive) {
  var animationDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 700;
  var duration = animationDuration;
  $('.form-step-active').fadeOut(duration, function () {
    $(this).removeClass('form-step-active');
    $(this).css('display', '');
    $('.form-step-' + stepToActive).fadeIn(duration, function () {
      $('.progress-bar .step').removeClass('active');
      for (var i = 1; i <= stepToActive; i++) {
        $('.progress-bar .step:nth-child(' + i + ')').addClass('active');
      }
      formLabelsEqual();
      $(this).addClass('form-step-active');
      $(this).css('display', '');
    });
    setTimeout(function () {
      isStepAnimationStarted = false;
    }, duration);
  });
  if (stepToActive == 2) {
    $('#form-field-employment-information').trigger('change');
  }
}
function setActiveStep(argsObj) {
  var stepsArray = [1, 2];
  var stepToActive = 1;
  var stepValidData = {};
  var currentSection;
  var specifigSectionHasInvalidField = false;

  // auto change step
  if (argsObj.currentStep == 0) {
    for (var n in stepsArray) {
      currentSection = $('.form-step-' + stepsArray[n]);
      stepValidData = validActiveStep(currentSection, stepToActive);

      // if form section field has error

      if (!stepValidData.pass) {
        $('html, body').scrollTop(stepValidData.item.offset().top - 250);
        stepValidData.item.focus();
        break;
      }
      if (stepToActive < 2) stepToActive++;
    }
  } else {
    if (argsObj.action == 'prev') stepToActive = parseInt(argsObj.currentStep) - 1;
    if (argsObj.action == 'next') {
      stepToActive = parseInt(argsObj.currentStep) + 1;

      // check if curent step is valid
      currentSection = $('.form-step-' + argsObj.currentStep);
      stepValidData = validActiveStep(currentSection, argsObj.currentStep);

      // if form section field has error
      if (!stepValidData.pass) {
        // alert when not valid
        alert(translations["form field warning"]);
        $('html, body').scrollTop(stepValidData.item.offset().top - 250);
        stepValidData.item.focus();
        specifigSectionHasInvalidField = true;
      }
    }
    if (argsObj.action == 'point') {
      stepToActive = 1;
      for (var i = 1; i <= argsObj.currentStep; i++) {
        currentSection = $('.form-step-' + i);
        stepValidData = validActiveStep(currentSection, stepToActive);
        if (stepValidData.pass) {
          if (i == argsObj.currentStep) break;
          if (stepToActive < 3) stepToActive++;
        } else {
          $('html, body').scrollTop(stepValidData.item.offset().top - 250);
          setTimeout(function () {
            stepValidData.item.focus();
          }, 1200);
          break;
        }
      }
    }
  }
  if (specifigSectionHasInvalidField === false) {
    // animate step if nesseccery
    if (argsObj.animate == true) {
      if (isStepAnimationStarted) {
        return;
      }
      isStepAnimationStarted = true;
      animateFormStep(stepToActive);
    } else {
      $('.form-step-active').removeClass('form-step-active');
      $('.form-step-' + stepToActive).addClass('form-step-active');
      $('.progress-bar .step').removeClass('active');
      for (var i = 1; i <= stepToActive; i++) {
        $('.progress-bar .step:nth-child(' + i + ')').addClass('active');
      }
    }
  }
  if (stepToActive >= 2) {
    loadPrices();
  }
}
function loadForm(formData) {
  // prepare data
  if (formData !== false && _typeof(formData) === "object") {
    var retriveData = formData;
  } else {
    var retriveData = storageDataToObj();
    if (typeof retriveData === "undefined" || retriveData === "" || retriveData === null || $('#form').length <= 0) {
      $('.progress-bar .step:nth-child(1)').addClass('active');
      return;
    }
  }

  // load form field data
  if (retriveData && retriveData.fields && retriveData.fields.form) {
    var formItems = Object.keys(retriveData.fields.form);
    for (var i = 0; i < formItems.length; i++) {
      var $field = $('[name="form[' + formItems[i] + ']"]');
      if ($field.attr('type') == "radio") {
        $('[name="form[' + formItems[i] + ']"][value="' + retriveData.fields.form[formItems[i]] + '"]').prop("checked", true).trigger('change');
      } else if ($field.attr('type') == "checkbox") {
        if (retriveData.fields.form[formItems[i]] != '') $('[name="form[' + formItems[i] + ']"][value="' + retriveData.fields.form[formItems[i]] + '"]').trigger('change').prop("checked", true);
      } else if ($field.attr('type') == "file") {} else {
        // change format date
        if (['date-of-arrival', 'date-of-embarkation'].concat(_toConsumableArray(insuranceDateFieldsArray)).indexOf(formItems[i]) !== -1) {
          var dateFieldSeparator = '.';
          if (!showBasicDatePicker) {
            dateFieldSeparator = '/';
          }

          /*
           * - date base format : rrrr-mm-dd
           * - date form format mobile: dd.mm.rrrr
           * - date form format desktop: dd/mm/rrrr
           *
           */

          var dateOfArrivalVal = retriveData.fields.form[formItems[i]];
          if (dateOfArrivalVal) {
            var dateOfArrivalValArr = dateOfArrivalVal.split('-');
            if (!showBasicDatePicker) {
              dateOfArrivalVal = dateOfArrivalValArr[2] + dateFieldSeparator + dateOfArrivalValArr[1] + dateFieldSeparator + dateOfArrivalValArr[0];
            }
            retriveData.fields.form[formItems[i]] = dateOfArrivalVal;
          } else {
            retriveData.fields.form[formItems[i]] = '';
          }
        }
        $field.val(retriveData.fields.form[formItems[i]]).trigger('change');
      }
    }
  }

  // load step if application not completed
  setActiveStep({
    'currentStep': 0,
    'action': false,
    'animate': false
  });
}
function cookiesWarning() {
  var cookiesAccepted = getCookie("cookies") == "y";
  var $cookies = $('.cookie-warning');
  var $closeBtn = $('#cookie-close');
  if (!cookiesAccepted) $cookies.removeClass('hidden');
  $closeBtn.click(function (e) {
    e.preventDefault();
    setCookie("cookies", "y", 365);
    $cookies.addClass('hidden');
  });
}
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}
function deleteAllCookies() {
  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}
function isValidDate(dateString) {
  //console.log('isValidDate()');
  // First check for the pattern
  if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) return false;

  // Parse the date parts to integers
  var parts = dateString.split("/");
  var day = parseInt(parts[0], 10);
  var month = parseInt(parts[1], 10);
  var year = parseInt(parts[2], 10);

  // Check the ranges of month and year
  if (year < 1000 || year > 3000 || month == 0 || month > 12) return false;
  var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Adjust for leap years
  if (year % 400 == 0 || year % 100 != 0 && year % 4 == 0) monthLength[1] = 29;

  // Check the range of the day
  return day > 0 && day <= monthLength[month - 1];
}
;
function validateFieldsBefore($stopBefore, event) {
  $('#form input, #form select').each(function () {
    var $obj = $(this);
    if ($obj.attr('id') == $stopBefore.attr('id')) return false;else validateField($obj);
  });
}
function checkServerFile(fileName) {
  var dataTypeObj = debugMode === true ? {
    type: "html"
  } : {
    type: "json"
  };
  var result = 0;
  $.ajax({
    url: 'form-apply-eta-check-file',
    dataType: dataTypeObj.type,
    method: "POST",
    async: false,
    data: {
      name: fileName
    },
    success: function success(response) {
      if (response.status == false) {
        console.log('error php');
        console.log(response.message);
      } else {
        // check debug mode
        if (debugMode === true) {
          console.log('debug mode checkServerFile');
          console.log(response);
        } else {
          // console.log('file exist');

          result = response.message;
        }
      }
    },
    error: function error(response) {
      console.error('error ajax');
      console.error(response);
    }
  });
  return result;
}
function checkFileField(fieldId) {
  var isValid = true;
  ['form-field-user-photo', 'form-field-user-passport-scan', 'form-field-user-business-card-scan', 'form-field-hospital-medical-letter-scan', 'form-field-conference-organizer-invitation-scan', 'form-field-conference-MEA-clearance-scan', 'form-field-conference-MHA-clearance-scan', 'form-field-invitation-from-the-company', 'form-field-invitation-letter-voluntary'].forEach(function (fieldName) {
    if (fieldId === fieldName) {
      var uploadValidate = $("#".concat(fieldName));
      var uploadHolderValidate = $("#".concat(fieldName, "-holder"));
      if (uploadHolderValidate.val() !== '') {
        uploadValidate.removeClass("file-with-error");
        var checkFile = checkServerFile(uploadHolderValidate.val());
        if (checkFile === 1) {
          uploadValidate.addClass("file-with-success");
        }
      }
      if (!uploadValidate.hasClass('file-with-success')) {
        isValid = false;
        uploadValidate.addClass("file-with-error");
      }
    }
  });
  return isValid;
}
function diffDates(dateObj) {
  var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

  return Math.round((dateObj.first.getTime() - dateObj.second.getTime()) / oneDay);
}
function getToodayDate() {
  var dateStart = new Date();
  var year = dateStart.getFullYear();
  var month = dateStart.getMonth();
  var day = dateStart.getDate();
  return new Date(year, month, day, 1, 0, 0, 0);
}
function validateField($field) {
  var isValid = true;
  var fieldType = $field.attr('type');
  var isRequired = $field.attr('data-required') !== undefined;
  if ($field.length === 0) {
    return false;
  }
  if (fieldType == "checkbox") {
    if ($field.prop('name') == 'form[invoice]') {
      isValid = true;
    } else if ($field.prop('checked') == false) {
      isValid = false;
    }
    $field = $field.closest('label');
  } else if (fieldType == "radio") {
    var v = $('[name="' + $field.attr('name') + '"]:checked').val();
    if (v == null || typeof v == "undefined") {
      isValid = false;
    }
    if (!$field.is(':visible')) {
      isValid = true;
    }
    if ($field.closest('.radio-column').length > 0) {
      $field = $field.closest('.radio-column').find('label');
    } else if ($field.closest('.insurance-question').length > 0) {
      $field = $field.closest('.insurance-question').find('label');
    }
  } else if (fieldType == "file") {
    if (validateOn) {
      isValid = checkFileField($field.attr('id'));
    }
  } else {
    if ($field.val() == null || typeof $field.val() === "undefined") {
      isValid = false;
    } else {
      var f = $field.val();
      if (typeof f == "string" && f.trim() == "") isValid = false;
    }
  }
  if ($field.attr('id') == "form-field-contact-email-repeat") {
    if ($('#form-field-contact-email').val() !== $field.val()) isValid = false;
  }
  if ($field.attr('id') == "form-field-contact-email") {
    validateField($('#form-field-contact-email-repeat'));
  }
  if (fieldType == "email") {
    var regEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!regEx.test($field.val())) {
      isValid = false;
    }
  }
  if ($field.parent().hasClass('hidden-vs') || ['form[travel-insurance-answer]', 'form[travel-insurance-start-date]', 'form[travel-insurance-end-date]'].indexOf($field.attr('name')) >= 0 && $('[name="form[travel-insurance]"]:checked').val() === "1" || ['form[travel-insurance-start-date]', 'form[travel-insurance-end-date]'].indexOf($field.attr('name')) >= 0 && $('[name="form[travel-insurance-answer]"]:checked').val() === "0") {
    isValid = true;
  }
  if ($field.hasClass('hasDatepicker') && $field.val() != "" && $field.val() != null && !['form-field-travel-insurance-start-date', 'form-field-travel-insurance-end-date'].indexOf($field.attr('id')) >= 0) {
    isValid = isValidDate($field.val());
  }
  if (window.insuranceEnabled) {
    var insuranceValidity = validateInsuranceFields($field, event);
    if (insuranceValidity === false) {
      isValid = false;
    } else if (insuranceValidity === undefined) {
      return true;
    }
  }
  if (['form-field-date-of-arrival', 'date-of-embarkation'].includes($field.attr('id')) && $field.val() != null && !showBasicDatePicker) {
    // input date
    var fieldDateValue = $('#' + $field.attr('id')).val();
    var fieldDateValueArray = fieldDateValue.split('/');
    var fieldDateMonthValue = fieldDateValueArray[1] - 1;
    var fieldDate = new Date(fieldDateValueArray[2], fieldDateMonthValue, fieldDateValueArray[0], 1, 0, 0, 0);
    var currentDate = getToodayDate(); //today

    var diffDays = diffDates({
      first: fieldDate,
      second: currentDate
    });
    if (diffDays >= adddays) {
      isValid = true;
    } else {
      isValid = false;
    }
    if (diffDays > 14) {
      validateOn = false;
      // show "I will upload photos later" on photo upload page
      $('.photolater').removeClass('hidden');
      if ($('[name="form[photolater]"]').prop('checked') && !$('.file-data-container').hasClass('hidden')) {
        $('.file-data-container').addClass('hidden');
      }
    } else {
      validateOn = true;
      $('.photolater').addClass('hidden');
      if ($('.file-data-container').hasClass('hidden')) {
        $('.file-data-container').removeClass('hidden');
      }
    }
    if (fieldDate.getYear() < currentDate.getYear()) isValid = false;
  } else if (['form-field-date-of-arrival', 'date-of-embarkation'].includes($field.attr('id')) && $field.val() != "" && $field.val() != null && showBasicDatePicker) {
    var arrivalField = $('#form-field-date-of-arrival');
    var arrivalFieldVal = arrivalField.val();
    var arrivalFieldValMin = arrivalField.attr('min');
    var arrivalFieldValMax = arrivalField.attr('max');
    var currentDate = getToodayDate(); //today

    var dVal = new Date(arrivalFieldVal);
    var dMin = new Date(arrivalFieldValMin);
    var dMax = new Date(arrivalFieldValMax);
    var diffDays = diffDates({
      first: dVal,
      second: currentDate
    });
    if (diffDays > 14) {
      validateOn = false;
      $('.photolater').removeClass('hidden');
      if ($('[name="form[photolater]"]').prop('checked') && !$('.file-data-container').hasClass('hidden')) {
        $('.file-data-container').addClass('hidden');
      }
    } else {
      validateOn = true;
      $('.photolater').addClass('hidden');
      if ($('.file-data-container').hasClass('hidden')) {
        $('.file-data-container').removeClass('hidden');
      }
    }
    if (dMin.getTime() > dVal.getTime() || dMax.getTime() < dVal.getTime()) {
      isValid = false;
    } else {
      isValid = true;
    }
  }
  if (fieldType != "file") {
    if ($field.find('input').attr('name') !== 'form[travel-insurance-answer]' && !['form[travel-insurance-start-date]', 'form[travel-insurance-end-date]'].indexOf($field.attr('name')) >= 0) {
      if (isValid) {
        $field.removeClass('with-error').addClass('with-success');
        var errorText = $field.closest('.fields-column').find('.form-field-error');
        if (errorText) {
          errorText.text('').addClass('hidden');
        }
      } else {
        if (isRequired || $field.val() != "" && $field.val() != null) {
          $field.removeClass('with-success').addClass('with-error');
        } else {
          $field.removeClass('with-error').addClass('with-success');
        }
        if (typeof visitedChina !== 'undefined') {
          $field.removeClass('with-success').addClass('with-error');
        }
      }
    }
  }

  // add or remove field from "validation-data"
  var validationData = $('#form-field-validation-data').val();
  var incomingFieldName = $field.attr('name');
  if (fieldType == "radio" || fieldType == "checkbox") {
    incomingFieldName = $($field.find('input')[0]).attr('name');
  }
  incomingFieldName = incomingFieldName.replace('form[', '');
  incomingFieldName = incomingFieldName.replace(']', '');
  if (validationData != undefined) {
    validationData = validationData.substring(0, validationData.length - 1);
    validationData = validationData.split(';');
    if (validationData[0] === '') {
      validationData.pop();
    }
    var incomingFieldNameArrayIndex = validationData.indexOf(incomingFieldName);
    if (isValid && incomingFieldNameArrayIndex === -1) {
      validationData.push(incomingFieldName);
    }
    if ((fieldType === "file" && $field.val() === '' && !validateOn || !isValid) && incomingFieldNameArrayIndex >= 0) {
      validationData.splice(incomingFieldNameArrayIndex, 1);
    }
  }
  validationData = validationData.join(';');
  $('#form-field-validation-data').val(validationData + ';');
  if ($field.attr('id') == 'form-field-birth-day' || $field.attr('id') == 'form-field-birth-month' || $field.attr('id') == 'form-field-birth-year') {
    var selectedValues = {
      day: parseInt($('#form-field-birth-day option:selected').text()) || null,
      month: $('#form-field-birth-month option:selected').prevAll().length || null,
      year: parseInt($('#form-field-birth-year option:selected').text()) || null
    };
    if (selectedValues.day && selectedValues.month && selectedValues.year) {
      var selectedDate = new Date(selectedValues.year, selectedValues.month - 1, selectedValues.day);
      var selectedMonthLength = new Date(selectedValues.year, selectedValues.month, 0).getDate();
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      if (selectedMonthLength < selectedValues.day || selectedDate > today) {
        isValid = false;
        $('#form-field-birth-day').removeClass('with-success').addClass('with-error');
        $('#form-field-birth-month').removeClass('with-success').addClass('with-error');
        $('#form-field-birth-year').removeClass('with-success').addClass('with-error');
      } else {
        $('#form-field-birth-day').removeClass('with-error').addClass('with-success');
        $('#form-field-birth-month').removeClass('with-error').addClass('with-success');
        $('#form-field-birth-year').removeClass('with-error').addClass('with-success');
      }
    }
  }
  if ($field.attr('id') === 'form-field-patient-birth-day' || $field.attr('id') === 'form-field-patient-birth-month' || $field.attr('id') === 'form-field-patient-birth-year') {
    var patientDateValues = {
      day: parseInt($('#form-field-patient-birth-day option:selected').text()) || null,
      month: $('#form-field-patient-birth-month option:selected').prevAll().length || null,
      year: parseInt($('#form-field-patient-birth-year option:selected').text()) || null
    };
    if (patientDateValues.day && patientDateValues.month && patientDateValues.year) {
      var selectedPatientDate = new Date(patientDateValues.year, patientDateValues.month - 1, patientDateValues.day);
      var selectedPatientMonthLength = new Date(patientDateValues.year, patientDateValues.month, 0).getDate();
      var _today = new Date();
      _today.setHours(0, 0, 0, 0);
      if (selectedPatientMonthLength < patientDateValues.day || selectedPatientDate > _today) {
        isValid = false;
        $('#form-field-patient-birth-day').removeClass('with-success').addClass('with-error');
        $('#form-field-patient-birth-month').removeClass('with-success').addClass('with-error');
        $('#form-field-patient-birth-year').removeClass('with-success').addClass('with-error');
      } else {
        $('#form-field-patient-birth-day').removeClass('with-error').addClass('with-success');
        $('#form-field-patient-birth-month').removeClass('with-error').addClass('with-success');
        $('#form-field-patient-birth-year').removeClass('with-error').addClass('with-success');
      }
    }
  }
  return isValid;
}

// get all key->val array from form
function getFieldsForm() {
  var out = {},
    $form = $('#form'),
    $fields = $form.find('input, select, textarea').not('input[type="file"]');
  $fields.each(function () {
    var type = $(this).attr('type');
    var name = $(this).attr('name');
    var value = $(this).val();
    name = name.replace('form[', '').replace(']', '');
    switch (type) {
      case 'radio':
        {
          if ($(this).parents().hasClass('hidden')) {
            out[name] = 0;
          } else if ($(this).is(':checked')) {
            out[name] = value;
          } else if (out[name] === undefined) {
            out[name] = '';
          }
          break;
        }
      case 'checkbox':
        {
          var isChecked = $(this).is(':checked');
          if (isChecked) {
            out[name] = value;
          } else if (out[name] === undefined) {
            out[name] = '';
          }
          break;
        }
      default:
        {
          if (['date-of-arrival', 'date-of-embarkation'].concat(_toConsumableArray(insuranceDateFieldsArray)).indexOf(name) !== -1) {
            if (!showBasicDatePicker && value.length > 0) {
              var dateSep = '-';
              var valueArr = value.split('/');
              value = valueArr[2] + dateSep + valueArr[1] + dateSep + valueArr[0];
            }
          }
          out[name] = value;
          break;
        }
    }
  });
  return JSON.stringify({
    'form': out
  });
}

// initialize application in base
function initializeApplicationInBase(dataObj) {
  var dataTypeObj = {
    type: debugMode === true ? "html" : "json"
  };
  $.ajax({
    url: 'form-apply-eta-initialize',
    dataType: dataTypeObj.type,
    method: "POST",
    async: false,
    data: {
      formData: dataObj
    },
    success: function success(response) {
      if (response.status === false) {
        console.log('error php');
        console.log(response.message);
      } else {
        // check debug mode
        if (debugMode === true) {
          console.log('debug mode initializeApplicationInBase');
          console.log(response);
        } else {
          // set localStorage
          if (typeof Storage !== "undefined") {
            var r_m = response.message.orderData;
            var outObj = {
              initializeData: {
                hash: r_m.hash,
                application_no: r_m.id_str
              },
              fields: dataObj
            };
            var outData = JSON.stringify(outObj);
            if (!formsent) {
              if (isStorageUsing) {
                localStorage.setItem(formLocalStorageKey, outData);
                localStorage.setItem(formLocalStorageKey + '_date', Date.now());
              } else {
                localStorageInterface.setItem(formLocalStorageKey, outData);
                localStorageInterface.setItem(formLocalStorageKey + '_date', Date.now());
              }
            }
            // Show application number
            showApplicationNo();
          }
        }
      }
    },
    error: function error(response) {
      console.error('error ajax');
      console.error(response);
    }
  });
}

// save single field to base if storage is initialize else
function saveApplicationInBase() {
  if (!basicFieldsAreValid()) {
    return false;
  }
  var dataTypeObj = {
    type: debugMode === true ? "html" : "json"
  };
  var storageObj = isRecoveryPage ? getFormDataAsJson() : formIsInitialize();
  if (storageObj) {
    var dataObj = JSON.parse(getFieldsForm());
    // update base & storage
    $.ajax({
      url: 'form-apply-eta-field',
      dataType: dataTypeObj.type,
      method: "POST",
      data: {
        formData: dataObj,
        storageData: storageObj,
        disableMails: disableMails
      },
      success: function success(response) {
        // console.log('3');
        if (response.status === false) {
          console.log('error php');
          console.log(response.message);
        } else {
          // check debug mode
          if (debugMode === true) {
            console.log(response);
          } else {
            // set localStorage + show application no
            if (response.message != 1) {
              console.log('data was not update');
            }
            if (!isRecoveryPage) {
              try {
                var dataInStorage = storageDataToObj();
                var outObj = {
                  initializeData: {
                    hash: dataInStorage.initializeData.hash,
                    application_no: dataInStorage.initializeData.application_no
                  },
                  fields: dataObj
                };
                var outData = JSON.stringify(outObj);
                if (!formsent) {
                  if (isStorageUsing) {
                    localStorage.setItem(formLocalStorageKey, outData);
                    localStorage.setItem(formLocalStorageKey + '_date', Date.now());
                  } else {
                    localStorageInterface.setItem(formLocalStorageKey, outData);
                    localStorageInterface.setItem(formLocalStorageKey + '_date', Date.now());
                  }
                }
              } catch (e) {
                console.log('invalid json');
              }
            }
          }
        }
      },
      error: function error(response) {
        console.error('error ajax');
        console.error(response);
      }
    });
  }
}
function initializeApplication() {
  if (basicFieldsAreValid() && !formIsInitialize()) {
    //generate data to save
    var dataObj = getFieldsForm();
    initializeApplicationInBase(dataObj);
  }
}
function basicFieldsAreValid() {
  var mailField = $('#form-field-contact-email'),
    firstFieldValue = $('#form-field-contact-email').val(),
    secondFieldValue = $('#form-field-contact-email-repeat').val(),
    birthDDField = $('#form-field-birth-day'),
    birthMMField = $('#form-field-birth-month'),
    birthYYField = $('#form-field-birth-year');
  var notEmpty = firstFieldValue !== '' && secondFieldValue !== '' && birthDDField.val() !== null && birthMMField.val() !== null && birthYYField.val() !== null;
  if (notEmpty) {
    var isValid = firstFieldValue === secondFieldValue && validateField(mailField) && validateField(birthDDField) && validateField(birthMMField) && validateField(birthYYField);
    return isValid;
  }
  return false;
}
function formIsInitialize() {
  if (clearLocalStorage) {
    if (isStorageUsing) {
      localStorage.removeItem(formLocalStorageKey);
      localStorage.removeItem(formLocalStorageKey + '_date');
    } else {
      localStorageInterface.removeItem(formLocalStorageKey);
      localStorageInterface.removeItem(formLocalStorageKey + '_date');
    }
  }
  var arrayStorageData = storageDataToObj();
  var status = arrayStorageData !== undefined ? arrayStorageData : false;
  return status;
}
function storageDataToObj() {
  if (typeof Storage === "undefined") return;
  var data;
  if (isStorageUsing) {
    data = localStorage.getItem(formLocalStorageKey);
  } else {
    data = localStorageInterface.getItem(formLocalStorageKey);
  }
  if (typeof data === "undefined" || data === "" || data === null) return;
  return JSON.parse(data);
}
function validateBefoureSubmit(e) {
  var $form = $('#form');
  var $fields = $form.find('[data-required]');
  var output = true;

  // check all required fields
  for (var i = 0; i < $fields.length; i++) {
    var $obj = $($fields[i]);
    // remove from validate hidden fields
    var visible = !$obj.parents().hasClass('hidden') && $obj.is(':visible');
    if (visible) {
      var defaultValidateField = false;
      $obj.parents().map(function () {
        if (!validateOn) {
          var elemAttr = $(this).attr('data-always-validate');
          if (elemAttr === 'yes') defaultValidateField = true;
        }
      });
      if (!validateOn && !defaultValidateField) continue;

      // match form name
      var regex = new RegExp(/^form\[(.*?)\]$/);
      var match = regex.exec($obj.attr('name'));
      var isValid = validateField($obj, e);
      if (!isValid) {
        $('html, body').scrollTop($obj.offset().top - 250);
        $obj.focus();
        output = false;
      }
    }
  }
  return output;
}
function isValidFileName(fname) {
  var rg1 = /^[^\\/:\*\?"<>\|]+$/; //blokada http/ftp/wszystkiego co szkodliwe
  var rg2 = /^\./;
  //allow only image extension
  var rg3 = /\.(pdf|jpe?g|tiff?|png|webp|bmp|jif|heic|jfif)$/i;
  if (rg1.test(fname.val()) && !rg2.test(fname.val()) && rg3.test(fname.val())) {
    $('#form-field-user-photo').removeClass("file-with-error");
    $('#form-field-user-passport-scan').removeClass("file-with-error");
    $('#form-field-user-business-card-scan').removeClass("file-with-error");
    $('#form-field-hospital-medical-letter-scan').removeClass("file-with-error");
    $('#form-field-conference-organizer-invitation-scan').removeClass("file-with-error");
    $('#form-field-conference-MEA-clearance-scan').removeClass("file-with-error");
    $('#form-field-conference-MHA-clearance-scan').removeClass("file-with-error");
    $('#form-field-invitation-letter-voluntary').removeClass("file-with-error");
    return true;
  } else {
    $('#form-field-user-photo').addClass("file-with-error");
    $('#form-field-user-passport-scan').addClass("file-with-error");
    $('#form-field-user-business-card-scan').addClass("file-with-error");
    $('#form-field-hospital-medical-letter-scan').addClass("file-with-error");
    $('#form-field-conference-organizer-invitation-scan').addClass("file-with-error");
    $('#form-field-conference-MEA-clearance-scan').addClass("file-with-error");
    $('#form-field-conference-MHA-clearance-scan').addClass("file-with-error");
    $('#form-field-invitation-letter-voluntary').addClass("file-with-error");
    return false;
  }
}
var pakistaniFields = ['#form-field-birth-country', '#form-field-nationality', '#form-field-nationality-previous', '#form-field-passport-country', '#form-field-additional-passport-country', '#form-field-applicant-adress-country', '#form-field-father-nationality', '#form-field-father-country-of-birth', '#form-field-mother-nationality', '#form-field-mother-country-of-birth', '#form-field-spouse-nationality', '#form-field-spouse-country-of-birth', '#form-field-employment-company-country', '#form-field-patient-nationality', '#form-field-dov-saarc-country'];
function lockForm(state, fieldSelector) {
  var actualStep = $('.form-step-active');
  var allFormRows = _toConsumableArray($('.form-row'));
  var actualStepFormRows = _toConsumableArray(actualStep.children('.form-row'));
  var indexOfFormRowInActualStep = actualStepFormRows.indexOf(document.querySelector(fieldSelector).closest('.form-row'));
  var indexOfActualFormRow = allFormRows.indexOf(document.querySelector(fieldSelector).closest('.form-row'));
  if (state) {
    if (indexOfFormRowInActualStep === -1) {
      var fieldStepElement = $(fieldSelector).closest('.form-row').parent();
      var fieldStepId = /*#__PURE__*/_wrapRegExp(/form\x2Dstep\x2D(\d)/, {
        stepId: 1
      }).exec(fieldStepElement.attr('class').split(' ').find(function (className) {
        return /form-step-\d/.test(className);
      })).groups.stepId;
      animateFormStep(parseInt(fieldStepId), 0);
    }
    $('.not-eligible-information').removeClass('hidden');
    $('.submit-btn').addClass('hiddenByPakistan');
    $(allFormRows.slice(indexOfActualFormRow + 1)).addClass('hiddenByPakistan');
  } else {
    $('.not-eligible-information').addClass('hidden');
    $('.hiddenByPakistan').removeClass('hiddenByPakistan');
    $('.submit-btn').removeClass('hiddenByPakistan');
  }
}
function checkPakistani() {
  var isBlockedByPakistan = false;
  var blockedBy = null;
  pakistaniFields.forEach(function (fieldId) {
    if (!isBlockedByPakistan) {
      var fieldValue = parseInt($(fieldId).val(), 10);
      if ($(fieldId).is(':visible') && ($(fieldId).val() === '13410' || $(fieldId).val() === 'pakistan')) {
        isBlockedByPakistan = true;
        blockedBy = $(fieldId);
        lockForm(true, fieldId);
      } else if (fieldId === '#form-field-nationality' && $(fieldId).is(':visible') && BLOCKED_NATIONALITIES.includes(fieldValue)) {
        isBlockedByPakistan = true;
        blockedBy = $(fieldId);
        lockForm(true, fieldId);
      } else {
        lockForm(false, fieldId);
      }
    }
  });
  if (!isBlockedByPakistan) {
    var pakistanHeldAreaQuestionField = $('[name="form[pakistan-held-area-question]"][value="1"]');
    if (pakistanHeldAreaQuestionField.is(':visible') && pakistanHeldAreaQuestionField.is(':checked')) {
      lockForm(true, '[name="form[pakistan-held-area-question]"]');
      blockedBy = $('[name="form[pakistan-held-area-question]"][value="1"]');
    } else {
      lockForm(false, '[name="form[pakistan-held-area-question]"]');
    }
  }
  disableMails = isBlockedByPakistan;
  formBlocked = isBlockedByPakistan;
}
function processForm() {
  $('#form').submit(function (e) {
    var _this = this;
    e.preventDefault();
    saveApplicationInBase();
    $('.with-error').filter(function () {
      return $(_this).find('[name="form[terms]"]').length === 0;
    }).removeClass('with-error');
    //
    var photolater = true;
    var documentsToUpload = ["user-photo", "user-passport-scan", "user-business-card-scan", "hospital-medical-letter-scan", "invitation-from-the-company", "conference-organizer-invitation-scan", "conference-organizer-invitation-scan", "invitation-letter-voluntary"];
    if (!photolater && documentsToUpload.every(function (docName) {
      return document.querySelector("#form-field-".concat(docName, "-holder")).value !== '' && !isValidFileName($("#form-field-".concat(docName)));
    })) {
      alert(translations['invalid mimeType']);
      return;
    }
    var valid = validateBefoureSubmit(e);
    if (!document.querySelector('#form').checkValidity()) {
      return;
    }
    if (valid) {
      var $form = $('#form');
      if ($('.with-error').length > 0) {
        $('.with-error').removeClass('with-error');
      }
      var $submitBtn = $form.find('[type="submit"]');
      var data = isRecoveryPage ? getFormDataAsJson() : storageDataToObj();

      // set end of proccess
      $submitBtn.prop('disabled', true).addClass('loading');
      formsent = true;

      // form-apply-eta
      $('input, button').prop('disabled', true);
      $.ajax({
        url: $form.attr('action'),
        dataType: "json",
        method: "POST",
        data: {
          hash: data.initializeData.hash,
          testMode: 0
        },
        success: function success(response) {
          if (response.status === false) {
            formsent = false;
            alert(formErrorMessage);
            console.log(response.msg);
          } else {
            //  if form fields valid clear storage & go to info page
            if (isStorageUsing) {
              localStorage.removeItem(formLocalStorageKey);
              localStorage.removeItem(formLocalStorageKey + '_date');
            } else {
              localStorageInterface.removeItem(formLocalStorageKey);
              localStorageInterface.removeItem(formLocalStorageKey + '_date');
            }
            window.onbeforeunload = null;
            window.location = response.redirectURL;
          }
          $submitBtn.prop('disabled', false).removeClass('loading');
        },
        error: function error(response) {
          $('input, button').prop('disabled', false);
          alert(formErrorMessage);
          $submitBtn.prop('disabled', false).removeClass('loading');
        }
      });
    } else {
      alert(translations['form field warning']);
    }
  });
  $('#form button[type=submit]').click(function (e) {
    if (document.querySelector('#form').checkValidity()) {
      $('input[name="form[terms]"]').closest('label').removeClass('with-error');
    } else {
      $('input[name="form[terms]"]').closest('label').addClass('with-error');
    }
    if (!validateBefoureSubmit()) {
      e.preventDefault();
    }
  });

  // prevent to past text to email repeat field
  $('#form-field-contact-email-repeat').on('paste', function (e) {
    e.preventDefault();
  });

  // check email fields and initialize if nessery
  if (!isRecoveryPage) {
    $('#form-field-contact-email-repeat, #form-field-contact-email, #form-field-birth-day, #form-field-birth-month, #form-field-birth-year').on('change', function (e) {
      initializeApplication();
    });
  }

  //////
  // update field in base and localStorage if email and application is initialize
  //////
  $('#form input, #form textarea').not('input[type="file"]').on('input', function (e) {
    validateField($(this), e);
  });
  $('#form select,' + '#form input[type="radio"], input[type="checkbox"]' + '#form #form-field-date-of-arrival,' + '#form #form-field-date-of-embarkation,' + '#form input, #form textarea').on('change', function (e) {
    if (validateField($(this), e)) {
      saveApplicationInBase();
    }
    checkPakistani();
  });

  //////
  // Ajax photo upload
  //////
  $('#form input[type="file"]').on('change', function (e) {
    if (this.files[0] === null) {
      return;
    }
    var $obj = $(this);
    var $btn = $('#submitform');
    var $btnTxt = $('#submit-photo-text');
    var photo = new FormData();
    var $objId = $obj.attr('id');
    var $holder = $("#" + $objId + "-holder");
    var $holderName = $("#" + $objId + "-holder-name");
    var $close = $("#" + $objId + "-preview .close-preview");
    var $preview = $("#" + $objId + "-preview");
    var $previewIn = $("#" + $objId + "-preview .file-preview-in");
    var closeImgUrl = '/assets/img/x.svg'; // Set close image url
    var previewId = $preview.attr('id'); // Prepare preview content
    var control = $('#' + $objId + '-control');
    $previewIn = $($previewIn[0]);
    $preview.css('background-color', '#8B8E92');

    // Show loading...
    $preview.removeClass("hidden");
    $preview.parent().find(".loading").removeClass('hidden');

    // Reset ui
    // $holder.val("");
    $obj.removeClass("file-with-success").removeClass("file-with-error");

    // Disable submit
    $btn.prop('disabled', true).addClass('loading');

    // Show disablebutton text
    $btnTxt.removeClass("hidden");

    // Process file input
    photo.append($obj.attr('id'), this.files[0]);

    // Send
    $.ajax({
      url: uploadEndpoint,
      method: "POST",
      processData: false,
      contentType: false,
      dataType: "json",
      data: photo,
      success: function success(response) {
        if (response.status == true) {
          setTimeout(function () {
            var previewUrl = response.url.replace('\\', '/'); // Prepare preview url
            var okImgUrl = '/assets/img/ok.svg'; // Set ok image url
            $holderName.addClass('hidden');
            $holder.val(response.tmp_name);
            $obj.addClass("file-with-success");
            $btn.prop('disabled', false).removeClass('loading');
            $btnTxt.addClass("hidden");
            control.addClass('upload-success');
            control.removeClass('hidden upload-error');
            validateField($obj);
            // disabled get file button
            // $obj.prop('disabled', true);

            // update base
            saveApplicationInBase();

            // hide file field
            $obj.addClass("hidden");

            // Set default img for pdf/heic file
            if (['pdf', 'heic'].indexOf(response.extension) !== -1) {
              previewUrl = '/assets/img/' + response.extension + '.svg';
              $preview.css('background-color', 'transparent');
            }
            $('#' + previewId + ' .on-preview').attr('src', previewUrl);
            $('#' + previewId + ' .on-preview-ok').attr('src', okImgUrl);
            $('#' + previewId + ' .close-preview').attr('src', closeImgUrl);
            $previewIn.removeClass("hidden");
            $preview.parent().find(".loading").addClass('hidden');
          }, 1000);
        } else {
          var uploadedImg = $previewIn.find($('.on-preview'));
          // if image has src do nothing --> dont hide the image
          if (!uploadedImg.attr('src')) {
            alert(response.message);
            $obj.removeClass("file-with-success").addClass("file-with-error");
            $holderName.removeClass('hidden');
            $previewIn.addClass("hidden");
          }
          $btn.prop('disabled', false).removeClass('loading');
          $btnTxt.addClass("hidden");
          $preview.parent().find(".loading").addClass('hidden');
        }
      },
      error: function error(response) {
        $obj.removeClass("file-with-success").addClass("file-with-error");
        $btn.prop('disabled', false).removeClass('loading');
        $btnTxt.addClass("hidden");
        console.log(response.responseText);
        $preview.parent().find(".loading").addClass('hidden');
        $previewIn.addClass("hidden");
        $holderName.removeClass('hidden');
        control.removeClass('upload-success hidden');
        control.addClass('upload-error');
      }
    });
  });

  //////
  // Remove image
  //////

  $('.close-preview').on('click', function (e) {
    e.preventDefault();
    var previewId = $(this).closest('.row')[0].querySelector('.file-preview').getAttribute('id');
    var objId = previewId.replace('-preview', '');
    var fileFieldId = objId + '-holder';
    $.ajax({
      url: deleteEndpoint,
      method: "POST",
      dataType: "json",
      data: {
        hash: $('.form-application-hash').eq(0).text(),
        fieldName: fileFieldId.replace('form-field-', '')
      }
    }).fail(function () {
      $.post('/logger.php', {
        data: "JSERR " + window.location.href + " | ajax:" + deleteEndpoint + " | message: " + "Error on AJAX request"
      });
    }).always(function () {
      $('#' + objId).removeClass("file-with-success hidden").val('');
      $('#' + fileFieldId).removeAttr('value');
      $('#' + previewId).addClass("hidden");
      $('#' + previewId + ' .on-preview').removeAttr('src');
      $("#" + previewId + " .file-preview-in").addClass("hidden");
      $('#' + objId + '-control').addClass('hidden');
      $("#" + fileFieldId + "-name").removeClass('hidden');
      validateField($('#' + objId));
      saveApplicationInBase();
    });
  });
  $('.replace-file').on('click', function () {
    event.preventDefault();
    $(this).closest('.upload-documents-right')[0].querySelector('.file-upload-btn').click();
  });

  // set prev step
  $('.step-back-btn').on('click', function (e) {
    // set scroll on top
    window.scroll(0, 0);
    e.preventDefault();
    var currentStep = $(this).attr('data-step-no');
    setActiveStep({
      'currentStep': currentStep,
      'action': 'prev',
      'animate': true
    });
  });

  // set next step
  $('#form .step-btn').click(function (e) {
    // set scroll on top
    window.scroll(0, 0);
    e.preventDefault();
    var currentStep = $(this).attr('data-step-no');
    setActiveStep({
      'currentStep': currentStep,
      'action': 'next',
      'animate': true
    });
  });
}
function additionalCitizenshipHiddenForm() {
  // Hide show form
  var $formSelector = $('[name="form[additional-citizenship-q]"]');
  var $rows = $('.citizenship-answer');
  var $question = $('.citizenship-question');
  $formSelector.change(function () {
    var checked = $('[name="form[additional-citizenship-q]"]:checked').val() == 1;
    if (!checked) {
      $question.addClass('group-spacer');
      $rows.addClass('hidden-padding hidden');
    } else {
      $question.removeClass('group-spacer');
      $rows.removeClass('hidden-padding hidden');
    }
  }).trigger('change');

  //
  // More fields
  //
  var currentFields = 1;
  var maxFields = 10;
  var $btnP = $('<button />').addClass('submit-btn citizenship-btn btn-add').html('+');
  var $btnM = $('<button />').addClass('submit-btn citizenship-btn btn-remove').html('-');
  $('.citizenship-answer').append($btnP).append($btnM);
  $(document).on('click', '.citizenship-btn', function (e) {
    e.preventDefault();
    var $obj = $(this);
    var isAdd = $obj.hasClass('btn-add');
    if (isAdd) {
      if (currentFields + 1 > maxFields) return;
      currentFields += 1;
      $('#form-field-additional-citizenship-new-' + currentFields).parent().removeClass('hidden');
    } else {
      if (currentFields - 1 <= 0) return;
      console.log(currentFields);
      $('#form-field-additional-citizenship-new-' + currentFields).parent().addClass('hidden');
      currentFields -= 1;
    }
  });
}
function minorHiddenForm() {
  var $formSelector = $('[name="form[minor]"]');
  var $rows = $('.minor-employment-hide');
  $formSelector.change(function () {
    var $obj = $(this);
    var checked = $('[name="form[minor]"]:checked').val() == 1;
    if (checked) {
      $rows.addClass('hidden');
    } else {
      $rows.removeClass('hidden');
    }
  }).trigger('change');
}
function hiddenForm1() {
  var $formSelector = $('[name="form[long-term]"]');
  $formSelector.change(function () {
    var $obj = $(this);
    var $field1 = $('.hidden-uci-number');
    if ($obj.val() == 1) {
      $field1.removeClass('hidden');
    } else {
      $field1.addClass('hidden');
    }
  }).trigger('change');
}
function hiddenForm2() {
  var $formSelector = $('[name="form[question-tuberculosis]"]');
  $formSelector.change(function () {
    var $field1 = $('.hidden-tuberculosis-details');
    var checked = $('[name="form[question-tuberculosis]"]:checked').val();
    if (checked == 1) $field1.removeClass('hidden');else $field1.addClass('hidden');
  }).trigger('change');
}
function hiddenForm3() {
  var $formSelector = $('[name="form[question-regular-treatment]"]');
  var $targetRow = $('.row-kidney-disease');
  $formSelector.change(function () {
    formTreatmentState(-1);
    formTravelForTreatmentState(1);
    var $field1 = $('.hidden-kidney-disease');
    if ($(this).val() == 1) {
      $field1.removeClass('hidden');
      $targetRow.removeClass('hidden');
      $('[name="form[question-kidney-disease]"]').trigger('change');
    } else {
      $field1.addClass('hidden');
      $targetRow.addClass('hidden');
    }
  });
}
function hiddenForm4() {
  var $formSelector = $('[name="form[question-kidney-disease]"]');
  $formSelector.change(function () {
    var currentValue = $('[name="form[question-kidney-disease]"]:checked').val();
    formTravelForTreatmentState(currentValue);
    formTreatmentState(-1);
  }).trigger('change');
}
function hiddenForm5() {
  var $formSelector = $('[name="form[question-travel-for-treatment]"]');
  $formSelector.change(function () {
    var currentValue = $('[name="form[question-travel-for-treatment]"]:checked').val();
    formTreatmentState(currentValue);
  }).trigger('change');
}
function visaRejectedAndJailAnswer() {
  var $visaRejected = $('[name="form[question-visa-rejected]"]');
  var $visaRejectedAnswer = $('[name="form[question-visa-rejected-answer]"]');
  var visaRejectedIsChecked = false;
  var $jail = $('[name="form[question-jail]"]');
  var $jailAnswer = $('[name="form[question-jail-answer]"]');
  var jailIsChecked = false;
  var $rows = $('.visa-rejected-jail-answers');
  $visaRejected.change(function () {
    visaRejectedIsChecked = $('[name="form[question-visa-rejected]"]:checked').val() == 1;
    if (visaRejectedIsChecked) $visaRejectedAnswer.parent().removeClass('hidden-vs');else $visaRejectedAnswer.parent().addClass('hidden-vs');
    if (!visaRejectedIsChecked && !jailIsChecked) $rows.addClass('hidden');else $rows.removeClass('hidden');
  }).trigger('change');
  $jail.change(function () {
    jailIsChecked = $('[name="form[question-jail]"]:checked').val() == 1;
    if (jailIsChecked) $jailAnswer.parent().removeClass('hidden-vs');else $jailAnswer.parent().addClass('hidden-vs');
    if (!visaRejectedIsChecked && !jailIsChecked) $rows.addClass('hidden');else $rows.removeClass('hidden');
  }).trigger('change');
}
function jobHiddenForm() {
  var $toHide = $('.employment-field');
  var $selector = $('#form-field-employment-profession');
  $selector.change(function () {
    var currentVal = $(this).val();
    if (currentVal == 14842 || currentVal == 14839 || currentVal == 14840) $toHide.addClass('hidden');else $toHide.removeClass('hidden');
    if (currentVal == 14841) {
      $('#form-field-employment-position').parent().hide();
    } else if (currentVal != 14842 && currentVal != 14839 && currentVal != 14840) {
      $('#form-field-employment-position').parent().show();
    }
  });
}
function formTravelForTreatmentState(state) {
  var $targetRow = $('.row-travel-for-treatment');
  var $field1 = $('.hidden-travel-for-treatment');
  if (state == 0) {
    $field1.removeClass('hidden');
    $targetRow.removeClass('hidden');
  } else if (state == 1) {
    $field1.addClass('hidden');
    $targetRow.addClass('hidden');
  }
}
function formTreatmentState(state) {
  var $targetRow = $('.row-hospitalization, .row-insurance');
  var $targetRow2 = $('.row-treatment-plan');
  var $field1 = $('.hidden-treatment-plan');
  var $field2 = $('.hidden-hospitalization');
  var $field3 = $('.hidden-insurance');
  if (state == 1) {
    $field1.removeClass('hidden');
    $field2.addClass('hidden');
    $field3.addClass('hidden');
    $targetRow.addClass('hidden');
    $targetRow2.removeClass('hidden');
  } else if (state == 0) {
    $field1.addClass('hidden');
    $field2.removeClass('hidden');
    $field3.removeClass('hidden');
    $targetRow.removeClass('hidden');
    $targetRow2.addClass('hidden');
  } else if (state == -1) {
    $field1.addClass('hidden');
    $field2.addClass('hidden');
    $field3.addClass('hidden');
    $targetRow.addClass('hidden');
    $targetRow2.addClass('hidden');
  }
}
window.addEventListener('resize', formLabelsEqual);
cvvInfo();
function cvvInfo() {
  var circle = $('.green-hint');
  var infoBox = $('.cvv-information');
  if (window.innerWidth <= 800) {
    $(window).on('click', function (event) {
      if (!event.target.classList.contains('green-hint')) {
        infoBox.addClass('hidden');
      }
    });
    circle.on('click', function (event) {
      infoBox.removeClass('hidden');
    });
  } else {
    circle.on('mouseover', function (event) {
      infoBox.removeClass('hidden');
    });
    circle.on('mouseout', function (event) {
      infoBox.addClass('hidden');
    });
  }
}
$(document).ready(showUploadedImages);
function showUploadedImages() {
  var uploadSection = $('.upload-section');
  uploadSection.each(function (i, el) {
    var imgSection = $(uploadSection[i].querySelector('.photo-holder')).closest('.upload-documents-wrapper');
    var imgUrl = uploadSection[i].querySelector('.photo-holder').value;
    if (checkFileField(el.querySelector('input[type=file]').getAttribute('id'))) {
      $.ajax({
        url: '/uploads/temp/' + imgUrl,
        type: "GET",
        success: function success(response) {
          // check does it a html file -> then file doesn't exists because, ajax return hole html code
          var isDoctype = '';
          for (var l = 4; l <= 10; l++) {
            isDoctype += response[l];
          }
          if (isDoctype.toUpperCase() != 'DOCTYPE') {
            var filePreview = uploadSection.find('.file-preview-in');
            var displayImgHere = uploadSection.find('.file-preview-in .on-preview');
            var control = uploadSection.find('.file-preview-control');
            var holderName = uploadSection.find('.form-field-upload-holder-name');
            var uploadInput = uploadSection.find('.file-upload-btn');
            filePreview[i].classList.remove('hidden');
            filePreview[i].parentNode.classList.remove('hidden');
            displayImgHere[i].src = "/uploads/temp/" + imgUrl;
            displayImgHere[i].src = /.\.pdf/.test(imgUrl) ? '/assets/img/pdf.svg' : /.\.heic/.test(imgUrl) ? '/assets/img/heic.svg' : '/uploads/temp/' + imgUrl;
            control[i].classList.add('upload-success');
            control[i].classList.remove('hidden');
            control[i].classList.remove('upload-error');
            holderName[i].classList.add('hidden');
            uploadInput[i].classList.add('hidden');
          } else {
            // file doesn't exists, so remove value from input
            imgUrl = "";
          }
        }
      });
    }
  });
}
function showError(target, event, message) {
  event.preventDefault();
  var errorText = target.parentNode.querySelector('.form-field-error');
  target.classList.remove('with-success');
  target.classList.add('with-error');
  errorText.classList.remove('hidden');
  errorText.innerText = message;
}
$.fn.preventNonLatin = function () {
  /*
  CYRYLIC:
      u0400 - u052F
      u1C80 - u1C88
      u2DE0 - u2DFF
      uA640 - uA69F
  ARABIC SIGNS:
      u0600 - u077F
      u08A0 - u08BD
      u08D3 - u08FF
  CHINESE SIGNS:
      u2E80 - u2E99
      u2E9B - u2EF3
      u2F00 - u2FD5
      u3000 - u303F
      u3105 - u312F
      u3131 - u318E
      u3190 - u31BA
      u31C0 - u31E3
      u3200 - u321E
      u3220 - u32FE
      u3300 - u9FFF
      uA840 - uA877
      uF900 - uFA6D
      uFA70 - uFAD9
  */
  var nonLatinPattern = /[\u0400-\u052f\u1C80-\u1C88\u2DE0-\u2DFF\uA640-\uA69F\u0600-\u077F\u08A0-\u08BD\u08D3-\u08FF\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3000-\u303F\u3105-\u312F\u3131-\u318E\u3190-\u31BA\u31C0-\u31E3\u3200-\u321E\u3220-\u32FE\u3300-\u9FFF\uA840-\uA877\uF900-\uFA6D\uFA70-\uFAD9]/;
  this.keypress(function (e) {
    if (e.key.replace(nonLatinPattern, '') == '') {
      showError(this, e, translations['form label nonlatin error']);
    }
  });
  this.on('paste', function (e) {
    var pasteData;
    if (window.clipboardData !== undefined && window.clipboardData.getData !== undefined) {
      // IE
      pasteData = window.clipboardData.getData('text');
    } else if (e.originalEvent && e.originalEvent.clipboardData !== undefined && e.originalEvent.clipboardData.getData !== undefined) {
      pasteData = e.originalEvent.clipboardData.getData('text');
    }
    if (pasteData && pasteData.match(nonLatinPattern)) {
      showError(this, e, translations['form label nonlatin error']);
    }
  });
};
$('#form-field-name').preventNonLatin();
$('#form-field-surname').preventNonLatin();
function sortNumbers(a, b) {
  return a - b;
}

//snapshot check if browser is IE or EDGE
function browserIsIE() {
  // Opera 8.0+ (UA detection to detect Blink/v8-powered Opera)
  // var isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  // Firefox 1.0+
  //    var isFirefox = typeof InstallTrigger !== 'undefined';
  // Safari 3.0+
  var isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
    return p.toString() === "[object SafariRemoteNotification]";
  }(!window['safari'] || safari.pushNotification);
  // Internet Explorer 6-11
  var isIE = /*@cc_on!@*/false || !!document.documentMode;
  // Edge 20+
  //      var isEdge = !isIE && !!window.StyleMedia;
  // Chrome 1+
  //     var isChrome = !!window.chrome && !!window.chrome.webstore;
  // Blink engine detection
  //     var isBlink = (isChrome || isOpera) && !!window.CSS;
  var dualMonitors = window.screen.availLeft;
  if (isIE === true || isSafari === true || dualMonitors !== 0) {
    $('.photo-btn-wrapper').addClass('hidden');
    $('.snapshot-text').addClass('hidden');
  }
}
browserIsIE();
var getPrices = function getPrices(resolve) {
  var req = new XMLHttpRequest();
  var formdata = new FormData();
  var storageData = isRecoveryPage ? getFormDataAsJson() : storageDataToObj();
  var selectedNationality = parseInt($('[name="form[nationality]"]').val());
  var selectedVisaType = $('[name="form[dov-purpose]"]').val();
  storageData && storageData.initializeData && formdata.append('idStr', storageData.initializeData.application_no);
  selectedNationality && formdata.append('nationality', selectedNationality);
  selectedVisaType && formdata.append('visaType', selectedVisaType);
  formdata.append('currency', 'EUR');
  req.open('POST', '/prices', true);
  req.onreadystatechange = function () {
    if (req.readyState === 4) {
      if (req.status === 200) {
        resolve(JSON.parse(req.responseText));
      } else {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/logger.php', true);
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        xhr.send("message=CANNOT GET PRICES");
      }
    }
  };
  req.send(formdata);
};
function loadPrices() {
  getPrices(function (data) {
    updateDenialProtectionPrice(data);
    updatePriorityProcessingPrice(data);
    if (window.insuranceEnabled) {
      loadInsurancePrices(data);
    }
  });
}
function toggleFastTrack() {
  var portId = $('#form-field-port-of-arrival').val();
  var fastTrackPortsId = Object.keys(fastTrackPorts);
  var isPortEligibleForFastTrack = fastTrackPortsId.includes(portId);
  showFastTrackQuestion(isPortEligibleForFastTrack, portId);
}
function showFastTrackQuestion(isEnabled, portId) {
  var fastTrackQuestionField = $(".fast-track-question");
  var fastTrackFields = $('.fast-track-flight-fields');
  if (isEnabled) {
    fastTrackQuestionField.removeClass('hidden');
    showFastTrackFields();
    setFastTrackPrice(portId);
  } else {
    fastTrackQuestionField.addClass('hidden');
    fastTrackFields.addClass('hidden');
  }
}
function showFastTrackFields() {
  var fastTrackDescription = $('.fast-track-cnt');
  var fastTrackFields = $('.fast-track-flight-fields');
  var fastTrackQuestionRadio = $('[name="form[fast-track]"]');
  var fastTrackUploadDocuments = $('.hiddenFastTrack');
  fastTrackQuestionRadio.on('change', function () {
    if ($('[name="form[fast-track]"]:checked').val() === "1") {
      fastTrackDescription.removeClass('hidden');
      fastTrackFields.removeClass('hidden');
      fastTrackUploadDocuments.removeClass('hidden');
    } else {
      fastTrackDescription.addClass('hidden');
      fastTrackFields.addClass('hidden');
      fastTrackUploadDocuments.addClass('hidden');
    }
  }).trigger('change');
  fastTrackQuestionRadio.closest('.fields-column').removeClass('with-error');
  fastTrackQuestionRadio.closest('label').removeClass('with-error');
}
function setFastTrackPrice(portId) {
  var productPrice = fastTrackPorts[portId] ? fastTrackPorts[portId].productPrice : null;
  if (productPrice) {
    $('.fast-track-price').removeClass('hidden');
    $('.form-fast-track-price').text(productPrice + ' EUR');
  }
}
function updateDenialProtectionPrice(prices) {
  if (!window.denialProtectionEnabled || !prices['denial_protection']) {
    return;
  }
  var denialProtectionLabel = $('.denial-protection-section .form-row-heading');
  if (!denialProtectionLabel.text().includes('+')) {
    var denialProtectionPrice = prices['denial_protection'].toFixed(2);
    denialProtectionLabel.append("(+".concat(denialProtectionPrice, " ").concat(prices.currency, ")"));
  }
}
function updatePriorityProcessingPrice(prices) {
  if (!window.priorityProcessingEnabled || !prices['priority_processing']) {
    return;
  }
  var priorityProcessingPrice = prices['priority_processing'].toFixed(2);
  $('#priority-processing-price').text('(+'.concat(priorityProcessingPrice, ' ', prices.currency, ')'));
}
function initializeTermsLogic() {
  $('input[name="form[terms-accept-all]"]').on('change', function () {
    $('.terms-margin input[type="checkbox"]').prop('checked', $(this).prop('checked')).trigger('change');
  });
  $('.terms-margin input[type="checkbox"]').on('change', function () {
    if (!$(this).prop('checked')) {
      $('input[name="form[terms-accept-all]"]').prop('checked', false);
    } else {
      var allChecked = true;
      $('.terms-margin input[type="checkbox"]').each(function () {
        if (!$(this).prop('checked')) {
          allChecked = false;
        }
      });
      $('input[name="form[terms-accept-all]"]').prop('checked', allChecked);
    }
    setTimeout(function () {
      return saveApplicationInBase();
    }, 200);
  });
}